(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('axios')) :
    typeof define === 'function' && define.amd ? define(['exports', 'axios'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.olosagentsdk = {}, global.axios));
}(this, (function (exports, axios) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

    var WSAddresses = /** @class */ (function () {
        function WSAddresses(json) {
            this.wsAddressList = [];
            this.wsAddressList = json;
        }
        WSAddresses.prototype.Address = function (name) {
            return this.wsAddressList[name] ? this.wsAddressList[name] : '';
        };
        return WSAddresses;
    }());

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (g && (g = 0, op[0] && (_ = 0)), _) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var OlosAPI = /** @class */ (function () {
        function OlosAPI(name, token) {
            var _this = this;
            this.olosAPI = axios__default['default'].create({
                baseURL: name,
                headers: this.globalHeaders,
            });
            this.olosAPI.interceptors.request.use(function (config) {
                if (token.accessToken != '') {
                    config.headers.Authorization = token.tokenType + " " + token.accessToken;
                    return config;
                }
                return token.getToken().then(function () {
                    config.headers.Authorization = token.tokenType + " " + token.accessToken;
                    return config;
                });
            });
            this.olosAPI.interceptors.response.use(function (value) {
                Logger.getInstance().debug("API (" + value.config.url + ") : " + JSON.stringify(value.data));
                return value;
            }, function (error) { return __awaiter(_this, void 0, void 0, function () {
                var originalRequest;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            originalRequest = error.config;
                            if (!(error.response.status === 401 && !originalRequest._retry)) return [3 /*break*/, 2];
                            return [4 /*yield*/, token.getToken()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, this.olosAPI(originalRequest)];
                        case 2:
                            Logger.getInstance().error("API Error (" + error + ")");
                            return [2 /*return*/, Promise.reject(error)];
                    }
                });
            }); });
        }
        OlosAPI.prototype.APIInstance = function () {
            return this.olosAPI;
        };
        return OlosAPI;
    }());

    const createCache = (lastNumberWeakMap) => {
        return (collection, nextNumber) => {
            lastNumberWeakMap.set(collection, nextNumber);
            return nextNumber;
        };
    };

    /*
     * The value of the constant Number.MAX_SAFE_INTEGER equals (2 ** 53 - 1) but it
     * is fairly new.
     */
    const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER === undefined ? 9007199254740991 : Number.MAX_SAFE_INTEGER;
    const TWO_TO_THE_POWER_OF_TWENTY_NINE = 536870912;
    const TWO_TO_THE_POWER_OF_THIRTY = TWO_TO_THE_POWER_OF_TWENTY_NINE * 2;
    const createGenerateUniqueNumber = (cache, lastNumberWeakMap) => {
        return (collection) => {
            const lastNumber = lastNumberWeakMap.get(collection);
            /*
             * Let's try the cheapest algorithm first. It might fail to produce a new
             * number, but it is so cheap that it is okay to take the risk. Just
             * increase the last number by one or reset it to 0 if we reached the upper
             * bound of SMIs (which stands for small integers). When the last number is
             * unknown it is assumed that the collection contains zero based consecutive
             * numbers.
             */
            let nextNumber = lastNumber === undefined ? collection.size : lastNumber < TWO_TO_THE_POWER_OF_THIRTY ? lastNumber + 1 : 0;
            if (!collection.has(nextNumber)) {
                return cache(collection, nextNumber);
            }
            /*
             * If there are less than half of 2 ** 30 numbers stored in the collection,
             * the chance to generate a new random number in the range from 0 to 2 ** 30
             * is at least 50%. It's benifitial to use only SMIs because they perform
             * much better in any environment based on V8.
             */
            if (collection.size < TWO_TO_THE_POWER_OF_TWENTY_NINE) {
                while (collection.has(nextNumber)) {
                    nextNumber = Math.floor(Math.random() * TWO_TO_THE_POWER_OF_THIRTY);
                }
                return cache(collection, nextNumber);
            }
            // Quickly check if there is a theoretical chance to generate a new number.
            if (collection.size > MAX_SAFE_INTEGER) {
                throw new Error('Congratulations, you created a collection of unique numbers which uses all available integers!');
            }
            // Otherwise use the full scale of safely usable integers.
            while (collection.has(nextNumber)) {
                nextNumber = Math.floor(Math.random() * MAX_SAFE_INTEGER);
            }
            return cache(collection, nextNumber);
        };
    };

    const LAST_NUMBER_WEAK_MAP = new WeakMap();
    const cache = createCache(LAST_NUMBER_WEAK_MAP);
    const generateUniqueNumber = createGenerateUniqueNumber(cache, LAST_NUMBER_WEAK_MAP);

    const isCallNotification = (message) => {
        return message.method !== undefined && message.method === 'call';
    };

    const isClearResponse = (message) => {
        return message.error === null && typeof message.id === 'number';
    };

    const load = (url) => {
        // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
        const scheduledIntervalFunctions = new Map([[0, () => { }]]); // tslint:disable-line no-empty
        const scheduledTimeoutFunctions = new Map([[0, () => { }]]); // tslint:disable-line no-empty
        const unrespondedRequests = new Map();
        const worker = new Worker(url);
        worker.addEventListener('message', ({ data }) => {
            if (isCallNotification(data)) {
                const { params: { timerId, timerType } } = data;
                if (timerType === 'interval') {
                    const idOrFunc = scheduledIntervalFunctions.get(timerId);
                    if (typeof idOrFunc === 'number') {
                        const timerIdAndTimerType = unrespondedRequests.get(idOrFunc);
                        if (timerIdAndTimerType === undefined ||
                            timerIdAndTimerType.timerId !== timerId ||
                            timerIdAndTimerType.timerType !== timerType) {
                            throw new Error('The timer is in an undefined state.');
                        }
                    }
                    else if (typeof idOrFunc !== 'undefined') {
                        idOrFunc();
                    }
                    else {
                        throw new Error('The timer is in an undefined state.');
                    }
                }
                else if (timerType === 'timeout') {
                    const idOrFunc = scheduledTimeoutFunctions.get(timerId);
                    if (typeof idOrFunc === 'number') {
                        const timerIdAndTimerType = unrespondedRequests.get(idOrFunc);
                        if (timerIdAndTimerType === undefined ||
                            timerIdAndTimerType.timerId !== timerId ||
                            timerIdAndTimerType.timerType !== timerType) {
                            throw new Error('The timer is in an undefined state.');
                        }
                    }
                    else if (typeof idOrFunc !== 'undefined') {
                        idOrFunc();
                        // A timeout can be savely deleted because it is only called once.
                        scheduledTimeoutFunctions.delete(timerId);
                    }
                    else {
                        throw new Error('The timer is in an undefined state.');
                    }
                }
            }
            else if (isClearResponse(data)) {
                const { id } = data;
                const timerIdAndTimerType = unrespondedRequests.get(id);
                if (timerIdAndTimerType === undefined) {
                    throw new Error('The timer is in an undefined state.');
                }
                const { timerId, timerType } = timerIdAndTimerType;
                unrespondedRequests.delete(id);
                if (timerType === 'interval') {
                    scheduledIntervalFunctions.delete(timerId);
                }
                else {
                    scheduledTimeoutFunctions.delete(timerId);
                }
            }
            else {
                const { error: { message } } = data;
                throw new Error(message);
            }
        });
        const clearInterval = (timerId) => {
            const id = generateUniqueNumber(unrespondedRequests);
            unrespondedRequests.set(id, { timerId, timerType: 'interval' });
            scheduledIntervalFunctions.set(timerId, id);
            worker.postMessage({
                id,
                method: 'clear',
                params: { timerId, timerType: 'interval' }
            });
        };
        const clearTimeout = (timerId) => {
            const id = generateUniqueNumber(unrespondedRequests);
            unrespondedRequests.set(id, { timerId, timerType: 'timeout' });
            scheduledTimeoutFunctions.set(timerId, id);
            worker.postMessage({
                id,
                method: 'clear',
                params: { timerId, timerType: 'timeout' }
            });
        };
        const setInterval = (func, delay) => {
            const timerId = generateUniqueNumber(scheduledIntervalFunctions);
            scheduledIntervalFunctions.set(timerId, () => {
                func();
                // Doublecheck if the interval should still be rescheduled because it could have been cleared inside of func().
                if (typeof scheduledIntervalFunctions.get(timerId) === 'function') {
                    worker.postMessage({
                        id: null,
                        method: 'set',
                        params: {
                            delay,
                            now: performance.now(),
                            timerId,
                            timerType: 'interval'
                        }
                    });
                }
            });
            worker.postMessage({
                id: null,
                method: 'set',
                params: {
                    delay,
                    now: performance.now(),
                    timerId,
                    timerType: 'interval'
                }
            });
            return timerId;
        };
        const setTimeout = (func, delay) => {
            const timerId = generateUniqueNumber(scheduledTimeoutFunctions);
            scheduledTimeoutFunctions.set(timerId, func);
            worker.postMessage({
                id: null,
                method: 'set',
                params: {
                    delay,
                    now: performance.now(),
                    timerId,
                    timerType: 'timeout'
                }
            });
            return timerId;
        };
        return {
            clearInterval,
            clearTimeout,
            setInterval,
            setTimeout
        };
    };

    const createLoadOrReturnBroker = (loadBroker, worker) => {
        let broker = null;
        return () => {
            if (broker !== null) {
                return broker;
            }
            const blob = new Blob([worker], { type: 'application/javascript; charset=utf-8' });
            const url = URL.createObjectURL(blob);
            broker = loadBroker(url);
            // Bug #1: Edge up until v18 didn't like the URL to be revoked directly.
            setTimeout(() => URL.revokeObjectURL(url));
            return broker;
        };
    };

    // This is the minified and stringified code of the worker-timers-worker package.
    const worker$1 = `(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error('The given type "'.concat(i,'" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error('The given method "'.concat(s.method,'" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error('The given type "'.concat(d,'" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();`; // tslint:disable-line:max-line-length

    const loadOrReturnBroker = createLoadOrReturnBroker(load, worker$1);
    const clearTimeout$1 = (timerId) => loadOrReturnBroker().clearTimeout(timerId);
    const setTimeout$1 = (func, delay) => loadOrReturnBroker().setTimeout(func, delay);

    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
    var _callbacks = {};
    var trigger = function (evname, params) {
        evname = (evname || "").toLowerCase();
        integrationWebSocket === null || integrationWebSocket === void 0 ? void 0 : integrationWebSocket.sendEvent(evname, params);
        if (_callbacks[evname]) {
            _callbacks[evname].forEach(function (handler) { return handler(params); });
        }
    };
    var on = function (evname, callback) {
        evname = (evname || "").toLowerCase();
        _callbacks[evname] = _callbacks[evname] || [];
        _callbacks[evname].push(callback);
    };
    var off = function (evname, fn) {
        evname = (evname || "").toLowerCase();
        if (_callbacks[evname]) {
            _callbacks[evname] = fn
                ? _callbacks[evname].filter(function (handler) { return handler !== fn; })
                : null;
        }
    };
    var EventName = {
        1: 'LoginRequest',
        2: 'LoginResponse',
        3: 'LogoutRequest',
        4: 'LogoutResponse',
        5: 'LoginCampaign',
        6: 'LogoutCampaign',
        7: 'ScreenPop',
        8: 'MessageResquest',
        9: 'MessageResponse',
        10: 'MessageReceived',
        11: 'Typing',
        12: 'ChangeStatus',
        13: 'InactivityAlert',
        15: 'PauseResponse',
        16: 'QuitPauseRequest',
        17: 'QuitPauseResponse',
        18: 'DispositionRequest',
        19: 'DispositionResponse',
        20: 'DialogTerminated',
        21: 'CurrentDialogsRequest',
        22: 'CurrentDialogsResponse',
        23: 'Heartbeat',
        24: 'ListPauseReasonsRequest',
        25: 'ListPauseReasonsResponse',
        26: 'ListDispositionRequest',
        27: 'ListDispositionResponse',
        28: 'ResetInactivityTimerRequest',
        29: 'ResetInactivityTimerResponse',
        30: 'AsyncMessageReply',
        31: 'GetAsyncMessage',
        32: 'AsyncMessageListRequest',
        33: 'AsyncMessageHistoricalRequest',
        34: 'AsyncMessageReceived',
        35: 'AsyncMessageScreenPop',
        36: 'AsyncMessageRemoved',
        37: 'AsyncMessageListResponse',
        38: 'AsyncMessageHistoricalResponse',
        39: 'GetAsyncMessageError',
        40: 'AsyncMessageReplyResponse',
        41: 'AsyncMessageTimeout',
        42: 'Error',
        43: 'AsyncMessageDismissRequest',
        44: 'AsyncMessageDismissResponse',
        45: 'AsyncMessageListRepliedRequest',
        46: 'AsyncMessageListRepliedResponse',
        47: 'AsyncMessageResetReadingTimeoutRequest',
        48: 'AsyncMessageResetReadingTimeoutResponse',
        49: 'TransferRequest',
        50: 'TransferResponse',
        51: 'messageNotice',
        52: 'AssistantMode',
        53: 'getAmountCallsInQueue',
        54: 'consultingAssistedCampaignRequest',
    };

    var getAllEventObjectProps = function (evtObj) {
        if (!evtObj)
            return '';
        if (typeof evtObj !== 'object')
            return JSON.stringify(evtObj);
        var keys = Object.keys(evtObj);
        return keys.map(function (item) { return item + ": " + evtObj[item]; }).join(' ');
    };
    var objToUrlencoded = function (obj) {
        return Object.keys(obj)
            .map(function (key) { return key + "=" + encodeURIComponent(obj[key]); })
            .join('&');
    };

    var Token = /** @class */ (function () {
        function Token(url, user, password, clientID, clientSecret) {
            var _this = this;
            this._accessToken = '';
            this._tokenType = '';
            this._refreshToken = '';
            this._secondsToExpire = 0;
            this.getToken = function () {
                var params = {
                    username: _this._user,
                    password: _this._password,
                    grant_type: 'password',
                    client_id: _this._clientID,
                    client_secret: _this._clientSecret,
                };
                return new Promise(function (resolve, reject) {
                    _this._getTokenAPI
                        .post('token', objToUrlencoded(params))
                        .then(function (response) {
                        _this._accessToken = response.data.access_token;
                        _this._tokenType = response.data.token_type;
                        _this._refreshToken = response.data.refresh_token;
                        _this._secondsToExpire = response.data.expires_in;
                        window.localStorage.setItem('eaglleOlosTokenType', response.data.token_type);
                        window.localStorage.setItem('eaglleOlosAccessToken', response.data.access_token);
                        if (!!_this._timer)
                            clearTimeout$1(_this._timer);
                        _this._timer = setTimeout$1(_this.tokenExpired, _this._secondsToExpire * 1000);
                        resolve(response);
                    })
                        .catch(function (err) {
                        console.error(err);
                        reject(err);
                    });
                });
            };
            this.tokenExpired = function () {
                var params = {
                    grant_type: 'refresh_token',
                    refresh_token: _this._refreshToken,
                    client_id: _this._clientID,
                    client_secret: _this._clientSecret,
                };
                _this._getTokenAPI.post('token', objToUrlencoded(params)).then(function (response) {
                    _this._accessToken = response.data.access_token;
                    _this._tokenType = response.data.token_type;
                    _this._refreshToken = response.data.refresh_token;
                    _this._secondsToExpire = response.data.expires_in;
                    window.localStorage.setItem('eaglleOlosTokenType', response.data.token_type);
                    window.localStorage.setItem('eaglleOlosAccessToken', response.data.access_token);
                    trigger('onTokenUpdate', response.data);
                    if (!!_this._timer)
                        clearTimeout$1(_this._timer);
                    _this._timer = setTimeout$1(_this.tokenExpired, _this._secondsToExpire * 1000);
                }, function (error) {
                    _this.tokenExpired();
                    console.error(error);
                });
            };
            this._user = user;
            this._password = password;
            this._clientID = clientID;
            this._clientSecret = clientSecret;
            this._timer = 0;
            this._globalHeaders = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };
            this._getTokenAPI = axios__default['default'].create({
                baseURL: url,
                headers: this._globalHeaders,
            });
        }
        Object.defineProperty(Token.prototype, "accessToken", {
            get: function () {
                return this._accessToken;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Token.prototype, "tokenType", {
            get: function () {
                return this._tokenType;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Token.prototype, "cognitoToken", {
            set: function (token) {
                console.warn('set cognitoToken(): This method only works with createOlosCognito.');
            },
            enumerable: false,
            configurable: true
        });
        return Token;
    }());

    var IntegrationWebSocket = /** @class */ (function () {
        function IntegrationWebSocket(webSocketURL) {
            this.connected = false;
            this.ws = null;
            this.webSocketURL = webSocketURL;
            this.connectWebSocket();
        }
        IntegrationWebSocket.prototype.connectWebSocket = function () {
            var _this = this;
            this.ws = new WebSocket(this.webSocketURL);
            this.ws.onopen = function () {
                console.log('WebSocket connected');
                _this.connected = true;
            };
            this.ws.onclose = function () {
                console.log('WebSocket closed');
                _this.connected = false;
                // Reconnect on close
                setTimeout(function () {
                    _this.connectWebSocket();
                }, 1000);
            };
            this.ws.onerror = function () {
                console.error('WebSocket error');
                _this.connected = false;
            };
        };
        IntegrationWebSocket.prototype.sendEvent = function (eventType, eventData) {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                var event_1 = __assign({ type: eventType, timestamp: Date.now() }, eventData);
                this.ws.send(JSON.stringify(event_1));
                console.log("Event " + eventType + " sent:", event_1);
            }
            else {
                console.error('WebSocket is not open');
            }
        };
        IntegrationWebSocket.prototype.getStatus = function () {
            return this.connected ? 'Connected' : 'Connecting...';
        };
        return IntegrationWebSocket;
    }());

    function decodeBase64(base64, enableUnicode) {
        var binaryString = atob(base64);
        if (enableUnicode) {
            var binaryView = new Uint8Array(binaryString.length);
            for (var i = 0, n = binaryString.length; i < n; ++i) {
                binaryView[i] = binaryString.charCodeAt(i);
            }
            return String.fromCharCode.apply(null, new Uint16Array(binaryView.buffer));
        }
        return binaryString;
    }

    function createURL(base64, sourcemapArg, enableUnicodeArg) {
        var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
        var enableUnicode = enableUnicodeArg === undefined ? false : enableUnicodeArg;
        var source = decodeBase64(base64, enableUnicode);
        var start = source.indexOf('\n', 10) + 1;
        var body = source.substring(start) + (sourcemap ? '\/\/# sourceMappingURL=' + sourcemap : '');
        var blob = new Blob([body], { type: 'application/javascript' });
        return URL.createObjectURL(blob);
    }

    function createBase64WorkerFactory(base64, sourcemapArg, enableUnicodeArg) {
        var url;
        return function WorkerFactory(options) {
            url = url || createURL(base64, sourcemapArg, enableUnicodeArg);
            return new Worker(url, options);
        };
    }

    var WorkerFactory = createBase64WorkerFactory('Lyogcm9sbHVwLXBsdWdpbi13ZWItd29ya2VyLWxvYWRlciAqLwooZnVuY3Rpb24gKCkgewogICAgJ3VzZSBzdHJpY3QnOwoKICAgIHZhciBnZXROZXh0RXZlbnRMb29wID0gLyoqIEBjbGFzcyAqLyAoZnVuY3Rpb24gKCkgewogICAgICAgIGZ1bmN0aW9uIGdldE5leHRFdmVudExvb3AoKSB7CiAgICAgICAgICAgIHZhciBfdGhpcyA9IHRoaXM7CiAgICAgICAgICAgIHRoaXMuX3VybCA9ICcnOwogICAgICAgICAgICB0aGlzLl90bW8gPSAxNTAwOwogICAgICAgICAgICB0aGlzLl9uZXh0RXZ0VGltZW91dCA9IDA7CiAgICAgICAgICAgIHRoaXMuX3hociA9IG5ldyBYTUxIdHRwUmVxdWVzdCgpOwogICAgICAgICAgICB0aGlzLl9hdXRob3JpemF0aW9uID0gJyc7CiAgICAgICAgICAgIHRoaXMuc3RhcnRMb29wID0gZnVuY3Rpb24gKGFnZW50SWQsIGFnZW50RXZ0VXJsLCBhdXRob3JpemF0aW9uLCBvbkV2ZW50LCBvbkVycm9yKSB7CiAgICAgICAgICAgICAgICBfdGhpcy5fdXJsID0gYWdlbnRFdnRVcmwgKyAiP2FnZW50SWQ9IiArIGFnZW50SWQ7CiAgICAgICAgICAgICAgICBfdGhpcy5fYXV0aG9yaXphdGlvbiA9IGF1dGhvcml6YXRpb247CiAgICAgICAgICAgICAgICB2YXIgbmV4dEV2ZW50VGltZW91dCA9IGZ1bmN0aW9uICgpIHsKICAgICAgICAgICAgICAgICAgICBjbGVhclRpbWVvdXQoX3RoaXMuX25leHRFdnRUaW1lb3V0KTsKICAgICAgICAgICAgICAgICAgICBfdGhpcy5fbmV4dEV2dFRpbWVvdXQgPSBzZXRUaW1lb3V0KGZ1bmN0aW9uICgpIHsKICAgICAgICAgICAgICAgICAgICAgICAgX3RoaXMuc3RhcnRMb29wKGFnZW50SWQsIGFnZW50RXZ0VXJsLCBfdGhpcy5fYXV0aG9yaXphdGlvbiwgb25FdmVudCwgb25FcnJvcik7CiAgICAgICAgICAgICAgICAgICAgfSwgX3RoaXMuX3Rtbyk7CiAgICAgICAgICAgICAgICB9OwogICAgICAgICAgICAgICAgX3RoaXMuX3hociA9IG5ldyBYTUxIdHRwUmVxdWVzdCgpOwogICAgICAgICAgICAgICAgX3RoaXMuX3hoci5vcGVuKCdHRVQnLCBhZ2VudEV2dFVybCArICI/YWdlbnRJZD0iICsgYWdlbnRJZCwgdHJ1ZSk7CiAgICAgICAgICAgICAgICBfdGhpcy5feGhyLnNldFJlcXVlc3RIZWFkZXIoJ0F1dGhvcml6YXRpb24nLCBfdGhpcy5fYXV0aG9yaXphdGlvbik7CiAgICAgICAgICAgICAgICBfdGhpcy5feGhyLm9ubG9hZCA9IGZ1bmN0aW9uICgpIHsKICAgICAgICAgICAgICAgICAgICBfdGhpcy5fdG1vID0gMTUwMDsKICAgICAgICAgICAgICAgICAgICBpZiAoX3RoaXMuX3hoci5zdGF0dXMgPT09IDIwMCkgewogICAgICAgICAgICAgICAgICAgICAgICB0cnkgewogICAgICAgICAgICAgICAgICAgICAgICAgICAgdmFyIGV2dE9iaiA9IEpTT04ucGFyc2UoX3RoaXMuX3hoci5yZXNwb25zZVRleHQucmVwbGFjZSgvXlwofChcKTskKS9nLCAnJykpOwogICAgICAgICAgICAgICAgICAgICAgICAgICAgb25FdmVudChldnRPYmopOwogICAgICAgICAgICAgICAgICAgICAgICAgICAgaWYgKGV2dE9iaiAmJiBldnRPYmouYWdlbnRFdmVudFR5cGUgIT09ICdOb3RoaW5nJykKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBfdGhpcy5fdG1vID0gMDsKICAgICAgICAgICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgICAgICAgICBjYXRjaCAoZXJyKSB7CiAgICAgICAgICAgICAgICAgICAgICAgICAgICBvbkVycm9yKHsKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBtZXNzYWdlOiAnRXJyb3IgcGFyc2luZyBHZXROZXh0RXZlbnQgcmVzcG9uc2UnLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIG9yaWdpbmFsUmVzcG9uc2VUZXh0OiBfdGhpcy5feGhyLnJlc3BvbnNlVGV4dCwKICAgICAgICAgICAgICAgICAgICAgICAgICAgIH0pOwogICAgICAgICAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgICAgICAgICAgfQogICAgICAgICAgICAgICAgICAgIGVsc2UgewogICAgICAgICAgICAgICAgICAgICAgICBvbkVycm9yKHsKICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0YXR1czogX3RoaXMuX3hoci5zdGF0dXMsCiAgICAgICAgICAgICAgICAgICAgICAgICAgICBtZXNzYWdlOiAnRXJyb3IgcGFyc2luZyBHZXROZXh0RXZlbnQgcmVzcG9uc2UnLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgb3JpZ2luYWxSZXNwb25zZVRleHQ6IF90aGlzLl94aHIucmVzcG9uc2VUZXh0LAogICAgICAgICAgICAgICAgICAgICAgICB9KTsKICAgICAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgICAgICAgICAgbmV4dEV2ZW50VGltZW91dCgpOwogICAgICAgICAgICAgICAgfTsKICAgICAgICAgICAgICAgIF90aGlzLl94aHIub25lcnJvciA9IGZ1bmN0aW9uICgpIHsKICAgICAgICAgICAgICAgICAgICBvbkVycm9yKHsgbWVzc2FnZTogJ0dldE5leHRFdmVudCBYSFIgRXJyb3InIH0pOwogICAgICAgICAgICAgICAgICAgIF90aGlzLl90bW8gPSAxNTAwOwogICAgICAgICAgICAgICAgICAgIG5leHRFdmVudFRpbWVvdXQoKTsKICAgICAgICAgICAgICAgIH07CiAgICAgICAgICAgICAgICBfdGhpcy5feGhyLm9udGltZW91dCA9IGZ1bmN0aW9uICgpIHsKICAgICAgICAgICAgICAgICAgICBvbkVycm9yKHsgbWVzc2FnZTogJ0dldE5leHRFdmVudCBYSFIgVGltZW91dCcgfSk7CiAgICAgICAgICAgICAgICAgICAgX3RoaXMuX3RtbyA9IDE1MDA7CiAgICAgICAgICAgICAgICAgICAgbmV4dEV2ZW50VGltZW91dCgpOwogICAgICAgICAgICAgICAgfTsKICAgICAgICAgICAgICAgIF90aGlzLl94aHIuc2VuZChudWxsKTsKICAgICAgICAgICAgfTsKICAgICAgICAgICAgdGhpcy5zdG9wTG9vcCA9IGZ1bmN0aW9uICgpIHsKICAgICAgICAgICAgICAgIGNsZWFyVGltZW91dChfdGhpcy5fbmV4dEV2dFRpbWVvdXQpOwogICAgICAgICAgICAgICAgX3RoaXMuX25leHRFdnRUaW1lb3V0ID0gMDsKICAgICAgICAgICAgICAgIF90aGlzLl94aHIuYWJvcnQoKTsKICAgICAgICAgICAgfTsKICAgICAgICAgICAgdGhpcy51cGRhdGVUb2tlbiA9IGZ1bmN0aW9uIChhdXRob3JpemF0aW9uKSB7CiAgICAgICAgICAgICAgICBfdGhpcy5fYXV0aG9yaXphdGlvbiA9IGF1dGhvcml6YXRpb247CiAgICAgICAgICAgIH07CiAgICAgICAgfQogICAgICAgIHJldHVybiBnZXROZXh0RXZlbnRMb29wOwogICAgfSgpKTsKCiAgICB2YXIgbGlzdE9mTmV4dEV2ZW50ID0ge307CiAgICBzZWxmLmFkZEV2ZW50TGlzdGVuZXIoJ21lc3NhZ2UnLCBmdW5jdGlvbiAoZSkgewogICAgICAgIHZhciBfYSwgX2IsIF9jOwogICAgICAgIHZhciBtZXNzYWdlID0gZS5kYXRhIHx8IGU7CiAgICAgICAgdmFyIGFnZW50RXZ0VXJsID0gZSAmJiBlLmRhdGEgJiYgZS5kYXRhLmFnZW50RXZ0VXJsOwogICAgICAgIHN3aXRjaCAobWVzc2FnZS5ldmVudFR5cGUpIHsKICAgICAgICAgICAgY2FzZSAnaW5pdCc6CiAgICAgICAgICAgICAgICAhbGlzdE9mTmV4dEV2ZW50W2FnZW50RXZ0VXJsXQogICAgICAgICAgICAgICAgICAgID8gbGlzdE9mTmV4dEV2ZW50W2FnZW50RXZ0VXJsXSA9IG5ldyBnZXROZXh0RXZlbnRMb29wKCkKICAgICAgICAgICAgICAgICAgICA6IGNvbnNvbGUuZXJyb3IoIkVycm9yISBDYW5cJ3QgaW5pdGlhbGl6ZSBzYW1lIGV2ZW50IHR3aWNlLiIpOwogICAgICAgICAgICAgICAgYnJlYWs7CiAgICAgICAgICAgIGNhc2UgJ3N0b3AnOgogICAgICAgICAgICAgICAgKF9hID0gbGlzdE9mTmV4dEV2ZW50W2FnZW50RXZ0VXJsXSkgPT09IG51bGwgfHwgX2EgPT09IHZvaWQgMCA/IHZvaWQgMCA6IF9hLnN0b3BMb29wKCk7CiAgICAgICAgICAgICAgICBicmVhazsKICAgICAgICAgICAgY2FzZSAndXBkYXRlVG9rZW4nOgogICAgICAgICAgICAgICAgKF9iID0gbGlzdE9mTmV4dEV2ZW50W2FnZW50RXZ0VXJsXSkgPT09IG51bGwgfHwgX2IgPT09IHZvaWQgMCA/IHZvaWQgMCA6IF9iLnVwZGF0ZVRva2VuKGUuZGF0YS5hdXRob3JpemF0aW9uKTsKICAgICAgICAgICAgICAgIGJyZWFrOwogICAgICAgICAgICBjYXNlICdzdGFydCc6CiAgICAgICAgICAgICAgICAoX2MgPSBsaXN0T2ZOZXh0RXZlbnRbYWdlbnRFdnRVcmxdKSA9PT0gbnVsbCB8fCBfYyA9PT0gdm9pZCAwID8gdm9pZCAwIDogX2Muc3RhcnRMb29wKGUuZGF0YS5hZ2VudElkLCBhZ2VudEV2dFVybCwgZS5kYXRhLmF1dGhvcml6YXRpb24sIGZ1bmN0aW9uIChvYmopIHsgcmV0dXJuIHNlbGYucG9zdE1lc3NhZ2UoeyBldmVudFR5cGU6ICdldmVudCcsIGRhdGE6IG9iaiwgdXJsOiBhZ2VudEV2dFVybCB9KTsgfSwgZnVuY3Rpb24gKGVycikgeyByZXR1cm4gc2VsZi5wb3N0TWVzc2FnZSh7IGV2ZW50VHlwZTogJ2Vycm9yJywgZGF0YTogZXJyLCB1cmw6IGFnZW50RXZ0VXJsIH0pOyB9KTsKICAgICAgICAgICAgICAgIGJyZWFrOwogICAgICAgICAgICBkZWZhdWx0OgogICAgICAgICAgICAgICAgY29uc29sZS53YXJuKCdFdmVudCBub3QgbWFwcGVkOiAnLCBlLmRhdGEpOwogICAgICAgICAgICAgICAgYnJlYWs7CiAgICAgICAgfQogICAgfSk7Cgp9KCkpOwoK', null, false);
    /* eslint-enable */

    var TokenCognito = /** @class */ (function () {
        function TokenCognito(token) {
            var _this = this;
            this._accessToken = '';
            this._tokenType = '';
            this.getToken = function () {
                return new Promise(function (resolve) {
                    setTimeout$1(function () {
                        _this._accessToken = _this._token.access_token;
                        _this._tokenType = _this._token.token_type;
                        resolve({ data: _this._token });
                    }, 2000);
                });
            };
            this._token = token;
        }
        Object.defineProperty(TokenCognito.prototype, "accessToken", {
            get: function () {
                return this._accessToken;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TokenCognito.prototype, "tokenType", {
            get: function () {
                return this._tokenType;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TokenCognito.prototype, "cognitoToken", {
            set: function (token) {
                this._accessToken = token.access_token;
                this._tokenType = token.token_type;
                this._token = token;
            },
            enumerable: false,
            configurable: true
        });
        return TokenCognito;
    }());

    var wsAddresses;
    var agentCMDAPI;
    var agentEVT;
    var agentCLD;
    var mailingCMD;
    var voiceSupport;
    var agentConfigCMD;
    var integrationCMD;
    var tokenAPI;
    var softPhoneAPI;
    var mcxAPI;
    var recordingRetrieveAPI;
    var worker;
    var logsFlag;
    var integrationWebSocket;
    var createOlos = function (addrs, _a, logs, integrationWebSocketURL) {
        var user = _a.user, password = _a.password, clientID = _a.clientID, clientSecret = _a.clientSecret;
        wsAddresses = new WSAddresses(addrs);
        tokenAPI = new Token(getAddress("WebAPIAgentControl"), user, password, clientID, clientSecret);
        agentCMDAPI = new OlosAPI(getAddress('wsAgentCmd'), tokenAPI);
        agentEVT = new OlosAPI(getAddress('wsAgentEvt'), tokenAPI);
        agentCLD = new OlosAPI(getAddress('WsAgentCloud'), tokenAPI);
        mailingCMD = new OlosAPI(getAddress('wsMailingCmd'), tokenAPI);
        new OlosAPI(getAddress('wsUserConfig'), tokenAPI);
        voiceSupport = new OlosAPI(getAddress('wsVoiceSupport'), tokenAPI);
        agentConfigCMD = new OlosAPI(getAddress('wsAgentConfig'), tokenAPI);
        integrationCMD = new OlosAPI(getAddress('wsIntegration'), tokenAPI);
        softPhoneAPI = new OlosAPI(getAddress('wsSoftPhone'), tokenAPI);
        mcxAPI = new OlosAPI(getAddress('wsMcx'), tokenAPI);
        recordingRetrieveAPI = new OlosAPI(getAddress('wsRecordingRetrieve'), tokenAPI);
        logsFlag = logs || false;
        integrationWebSocket = integrationWebSocketURL ? new IntegrationWebSocket(integrationWebSocketURL) : null;
        Logger.getInstance().loggerWindow('Olos Created');
        worker = new WorkerFactory();
    };
    var createOlosCognito = function (addrs, _a, logs) {
        var token = _a.token;
        wsAddresses = new WSAddresses(addrs);
        tokenAPI = new TokenCognito(token);
        agentCMDAPI = new OlosAPI(getAddress('wsAgentCmd'), tokenAPI);
        agentEVT = new OlosAPI(getAddress('wsAgentEvt'), tokenAPI);
        agentCLD = new OlosAPI(getAddress('WsAgentCloud'), tokenAPI);
        mailingCMD = new OlosAPI(getAddress('wsMailingCmd'), tokenAPI);
        new OlosAPI(getAddress('wsUserConfig'), tokenAPI);
        voiceSupport = new OlosAPI(getAddress('wsVoiceSupport'), tokenAPI);
        agentConfigCMD = new OlosAPI(getAddress('wsAgentConfig'), tokenAPI);
        integrationCMD = new OlosAPI(getAddress('wsIntegration'), tokenAPI);
        softPhoneAPI = new OlosAPI(getAddress('wsSoftPhone'), tokenAPI);
        mcxAPI = new OlosAPI(getAddress('wsMcx'), tokenAPI);
        recordingRetrieveAPI = new OlosAPI(getAddress('wsRecordingRetrieve'), tokenAPI);
        logsFlag = logs || false;
        Logger.getInstance().loggerWindow('Olos Created');
        if (!worker)
            worker = new WorkerFactory();
    };
    var terminateWorker = function () {
        if (worker) {
            worker.terminate();
        }
    };
    var getAddress = function (wsName) {
        return wsAddresses === null || wsAddresses === void 0 ? void 0 : wsAddresses.Address(wsName);
    };
    var setCognitoToken = function (token) {
        tokenAPI.cognitoToken = token;
    };

    var Logger = /** @class */ (function () {
        function Logger() {
            var _this = this;
            this._logDateTime = function () { return new Date().toLocaleString(); };
            this._allLogs = [];
            this.loggerWindow = function (msg) {
                if (!logsFlag)
                    return;
                _this._allLogs.push({ type: 'LOGGER', msg: _this._logDateTime() + " " + msg.toString() });
                trigger('Logger', _this._allLogs);
            };
            this.error = function (msg) {
                if (!logsFlag)
                    return;
                _this._allLogs.push({ type: 'ERROR', msg: _this._logDateTime() + " " + msg.toString() });
                trigger('Logger', _this._allLogs);
            };
            this.info = function (msg) {
                if (!logsFlag)
                    return;
                _this._allLogs.push({ type: 'INFO', msg: _this._logDateTime() + " " + msg.toString() });
                trigger('Logger', _this._allLogs);
            };
            this.debug = function (msg) {
                if (!logsFlag)
                    return;
                _this._allLogs.push({ type: 'DEBUG', msg: _this._logDateTime() + " " + msg.toString() });
                trigger('Logger', _this._allLogs);
            };
        }
        Logger.getInstance = function () {
            if (!Logger.instance) {
                Logger.instance = new Logger();
            }
            return Logger.instance;
        };
        return Logger;
    }());

    var EnumAgentStatus = {
        NOTHING: { id: "NOTHING", value: "Nothing" },
        IDLE: { id: "IDLE", value: "Idle" },
        TALKING: { id: "TALKING", value: "Talking" },
        WRAP: { id: "WRAP", value: "Wrap" },
        PAUSE: { id: "PAUSE", value: "Pause" },
        ENDING: { id: "ENDING", value: "Ending" },
        TALKING_WITH_PAUSE: { id: "TALKING_WITH_PAUSE", value: "TalkingWithPause" },
        WRAP_WITH_PAUSE: { id: "WRAP_WITH_PAUSE", value: "WrapWithPause" },
        TALKING_WITH_ENDING: { id: "TALKING_WITH_ENDING", value: "TalkingWithEnding" },
        WRAP_WITH_ENDING: { id: "WRAP_WITH_ENDING", value: "WrapWithEnding" },
        CONSULTING: { id: "CONSULTING", value: "Consulting" },
        IN_CHAT: { id: "IN_CHAT", value: "Chat" },
        IN_CHAT_WITH_PAUSE: { id: "IN_CHAT_WITH_PAUSE", value: "ChatWithPause" },
        IN_CHAT_WITH_ENDING: { id: "IN_CHAT_WITH_ENDING", value: "ChatWithEnding" },
        CONSULTING_WITH_PAUSE: { id: "CONSULTING_WITH_PAUSE", value: "ConsultingWithPause" },
        CONSULTING_WITH_ENDING: { id: "CONSULTING_WITH_ENDING", value: "ConsultingWithEnding" },
        TRANSFER: { id: "TRANSFER", value: "Transfer" },
        HOLDING: { id: "HOLDING", value: "Holding" },
        HOLDING_WITH_PAUSE: { id: "HOLDING_WITH_PAUSE", value: "HoldingWithPause" },
        HOLDING_WITH_ENDING: { id: "HOLDING_WITH_ENDING", value: "HoldingWithEnding" },
        MANUAL_CALL: { id: "MANUAL_CALL", value: "ManualCall" },
        TALKING_WITH_MANUAL_CALL: { id: "TALKING_WITH_MANUAL_CALL", value: "TalkingWithManualCall" },
        WRAP_WITH_MANUAL_CALL: { id: "WRAP_WITH_MANUAL_CALL", value: "WrapWithManualCall" },
        CONSULTING_WITH_MANUAL_CALL: { id: "CONSULTING_WITH_MANUAL_CALL", value: "ConsultingWithManualCall" },
        HOLDING_WITH_MANUAL_CALL: { id: "HOLDING_WITH_MANUAL_CALL", value: "HoldingWithManualCall" },
        REDIAL: { id: "REDIAL", value: "Redial" },
        PRIVATE_CALLBACK: { id: "PRIVATE_CALLBACK", value: "PrivateCallback" },
        TALKING_WITH_PRIVATE_CALLBACK: { id: "TALKING_WITH_PRIVATE_CALLBACK", value: "TalkingWithPrivateCallback" },
        WRAP_WITH_PRIVATE_CALLBACK: { id: "WRAP_WITH_PRIVATE_CALLBACK", value: "WrapWithPrivateCallback" },
        MANUALCALL_WITH_PRIVATE_CALLBACK: { id: "MANUALCALL_WITH_PRIVATE_CALLBACK", value: "ManualCallWithPrivateCallback" },
        CONSULTING_WITH_PRIVATE_CALLBACK: { id: "CONSULTING_WITH_PRIVATE_CALLBACK", value: "ConsultingWithPrivateCallback" },
        HOLDING_WITH_PRIVATE_CALLBACK: { id: "HOLDING_WITH_PRIVATE_CALLBACK", value: "HoldingWithPrivateCallback" },
        THIRD_PARTY_CAMPAIGN: { id: "THIRD_PARTY_CAMPAIGN", value: "ThirdPartyCampaign" },
        PERSONAL_CALL: { id: "PERSONAL_CALL", value: "PersonalCall" },
        TALKING_WITH_PERSONAL_CALL: { id: "TALKING_WITH_PERSONAL_CALL", value: "TalkingWithPersonalCall" },
        WRAP_WITH_PERSONAL_CALL: { id: "WRAP_WITH_PERSONAL_CALL", value: "WrapWithPersonalCall" },
        MANUALCALL_WITH_PERSONAL_CALL: { id: "MANUALCALL_WITH_PERSONAL_CALL", value: "ManualCallWithPersonalCall" },
        CONSULTING_WITH_PERSONAL_CALL: { id: "CONSULTING_WITH_PERSONAL_CALL", value: "ConsultingWithPersonalCall" },
        HOLDING_WITH_PERSONAL_CALL: { id: "HOLDING_WITH_PERSONAL_CALL", value: "HoldingWithPersonalCall" },
        PERSONAL_CALL_WITH_ENDING: { id: "PERSONAL_CALL_WITH_ENDING", value: "PersonalCallWithEnding" },
        PERSONAL_CALL_WITH_PAUSE: { id: "PERSONAL_CALL_WITH_PAUSE", value: "PersonalCallWithPause" },
        Analyzing: { id: "Analyzing", value: "Analyzing" },
        AnalyzingWithPersonalCall: { id: "AnalyzingWithPersonalCall", value: "AnalyzingWithPersonalCall" },
        "Attempting ": { id: "Attempting ", value: "Attempting" },
        "AttemptingWithPersonalCall ": { id: "AttemptingWithPersonalCall", value: "AttemptingWithPersonalCall" },
        "AfterAttempting ": { id: "AfterAttempting ", value: "AfterAttempting" },
        "AfterAttemptWithPersonalCall  ": { id: "AfterAttemptWithPersonalCall  ", value: "AfterAttemptWithPersonalCall" },
        "AttemptingWithPrivateCallback  ": { id: "AttemptingWithPrivateCallback  ", value: "AttemptingWithPrivateCallback" },
        "RedialWithPersonalCall ": { id: "RedialWithPersonalCall ", value: "RedialWithPersonalCall" },
        InConference: { id: "InConference ", value: "InConference" },
        InConferenceWithEnding: { id: "InConferenceWithEnding ", value: "InConferenceWithEnding" },
        InConferenceWithManualCall: { id: "InConferenceWithManualCall ", value: "InConferenceWithManualCall" },
        InConferenceWithPause: { id: "InConferenceWithPause ", value: "InConferenceWithPause" },
        InConferenceWithPersonalCall: { id: "InConferenceWithPersonalCall ", value: "InConferenceWithPersonalCall" },
        InConferenceWithPrivateCallback: { id: "InConferenceWithPrivateCallback ", value: "InConferenceWithPrivateCallback" },
        PAUSING: { id: "PAUSING", value: "Pausing" },
        END: { id: "END", value: "End" },
    };
    var AgentEventType;
    (function (AgentEventType) {
        AgentEventType["NOTHING"] = "Nothing";
        AgentEventType["LOGIN_CCM"] = "LoginCCM";
        AgentEventType["LOGOUT_CCM"] = "LogoutCCM";
        AgentEventType["LOGIN_CAMPAIGN"] = "LoginCampaign";
        AgentEventType["LOGOUT_CAMPAIGN"] = "LogoutCampaign";
        AgentEventType["CHANGE_STATUS"] = "ChangeStatus";
        AgentEventType["SCREEN_POP"] = "ScreenPop";
        AgentEventType["CHANGE_STATUS_FAIL"] = "ChangeStatusFail";
        AgentEventType["DISPOSITION_REQUEST_FAIL"] = "DispositionRequestFail";
        AgentEventType["LOGIN_CCM_FAIL"] = "LoginCCMFail";
        AgentEventType["LOGIN_CAMPAIGN_FAIL"] = "LoginCampaignFail";
        AgentEventType["LOGOUT_CCM_FAIL"] = "LogoutCCMFail";
        AgentEventType["LOGOUT_CAMPAIGN_FAIL"] = "LogoutCampaignFail";
        AgentEventType["ONLINE_CAMPAIGN_CHANGE_STATUS_ID"] = "OnlineCampaignChangeStatusId";
        AgentEventType["PASS_CODE"] = "PassCode";
        AgentEventType["NEW_CHAT"] = "NewChat";
        AgentEventType["NEW_CHAT_MSG"] = "NewChatMsg";
        AgentEventType["END_CHAT"] = "EndChat";
        AgentEventType["NEW_MESSAGE"] = "NewMessage";
        AgentEventType["CONSULTING_REQUEST_FAIL"] = "ConsultingRequestFail";
        AgentEventType["ACTIVE_CALL"] = "ActiveCall";
        AgentEventType["MANUAL_CALL_REQUEST_FAIL"] = "ManualCallRequestFail";
        AgentEventType["CHANGE_MANUAL_CALL_STATE"] = "ChangeManualCallState";
        AgentEventType["REDIAL_REQUEST_FAIL"] = "RedialRequestFail";
        AgentEventType["REDIAL_SUCCESS"] = "RedialSuccess";
        AgentEventType["LIST_ACTIVE_CALLS"] = "ListActiveCalls";
        AgentEventType["PRIVATE_CALLBACK_FAIL"] = "PrivateCallbackFail";
        AgentEventType["THIRD_PARTY_SCREEN_POP"] = "ThirdPartyScreenPop";
        AgentEventType["ChangePreviewCallState"] = "ChangePreviewCallState";
        AgentEventType["ChangePreviewCallResult"] = "ChangePreviewCallResult";
        AgentEventType["ConferenceRequestAccepted"] = "ConferenceRequestAccepted";
        AgentEventType["ParticipantJoinedConference"] = "ParticipantJoinedConference";
        AgentEventType["StopConferenceRequestAccepted"] = "StopConferenceRequestAccepted";
        AgentEventType["ParticipantLeftConference"] = "ParticipantLeftConference";
        AgentEventType["ConferenceRequestFail"] = "ConferenceRequestFail";
        AgentEventType["StopConferenceRequestFail"] = "StopConferenceRequestFail";
        AgentEventType["ConferencePaused"] = "ConferencePaused";
        AgentEventType["ConferenceResumed"] = "ConferenceResumed";
        AgentEventType["ReferCallRequestFail"] = "ReferCallRequestFail";
    })(AgentEventType || (AgentEventType = {}));
    var AgentEventChatType;
    (function (AgentEventChatType) {
        AgentEventChatType[AgentEventChatType["LoginRequest"] = 1] = "LoginRequest";
        AgentEventChatType[AgentEventChatType["LoginResponse"] = 2] = "LoginResponse";
        AgentEventChatType[AgentEventChatType["LogoutRequest"] = 3] = "LogoutRequest";
        AgentEventChatType[AgentEventChatType["LogoutResponse"] = 4] = "LogoutResponse";
        AgentEventChatType[AgentEventChatType["LoginCampaign"] = 5] = "LoginCampaign";
        AgentEventChatType[AgentEventChatType["LogoutCampaign"] = 6] = "LogoutCampaign";
        AgentEventChatType[AgentEventChatType["ScreenPop"] = 7] = "ScreenPop";
        AgentEventChatType[AgentEventChatType["MessageResquest"] = 8] = "MessageResquest";
        AgentEventChatType[AgentEventChatType["MessageResponse"] = 9] = "MessageResponse";
        AgentEventChatType[AgentEventChatType["MessageReceived"] = 10] = "MessageReceived";
        AgentEventChatType[AgentEventChatType["Typing"] = 11] = "Typing";
        AgentEventChatType[AgentEventChatType["ChangeStatus"] = 12] = "ChangeStatus";
        AgentEventChatType[AgentEventChatType["InactivityAlert"] = 13] = "InactivityAlert";
        AgentEventChatType[AgentEventChatType["PauseRequest"] = 14] = "PauseRequest";
        AgentEventChatType[AgentEventChatType["PauseResponse"] = 15] = "PauseResponse";
        AgentEventChatType[AgentEventChatType["QuitPauseRequest"] = 16] = "QuitPauseRequest";
        AgentEventChatType[AgentEventChatType["QuitPauseResponse"] = 17] = "QuitPauseResponse";
        AgentEventChatType[AgentEventChatType["DispositionRequest"] = 18] = "DispositionRequest";
        AgentEventChatType[AgentEventChatType["DispositionResponse"] = 19] = "DispositionResponse";
        AgentEventChatType[AgentEventChatType["DialogTerminated"] = 20] = "DialogTerminated";
        AgentEventChatType[AgentEventChatType["CurrentDialogsRequest"] = 21] = "CurrentDialogsRequest";
        AgentEventChatType[AgentEventChatType["CurrentDialogsResponse"] = 22] = "CurrentDialogsResponse";
        AgentEventChatType[AgentEventChatType["Heartbeat"] = 23] = "Heartbeat";
        AgentEventChatType[AgentEventChatType["ListPauseReasonsRequest"] = 24] = "ListPauseReasonsRequest";
        AgentEventChatType[AgentEventChatType["ListPauseReasonsResponse"] = 25] = "ListPauseReasonsResponse";
        AgentEventChatType[AgentEventChatType["ListDispositionRequest"] = 26] = "ListDispositionRequest";
        AgentEventChatType[AgentEventChatType["ListDispositionResponse"] = 27] = "ListDispositionResponse";
        AgentEventChatType[AgentEventChatType["ResetInactivityTimerRequest"] = 28] = "ResetInactivityTimerRequest";
        AgentEventChatType[AgentEventChatType["ResetInactivityTimerResponse"] = 29] = "ResetInactivityTimerResponse";
        AgentEventChatType[AgentEventChatType["AsyncMessageReply"] = 30] = "AsyncMessageReply";
        AgentEventChatType[AgentEventChatType["GetAsyncMessage"] = 31] = "GetAsyncMessage";
        AgentEventChatType[AgentEventChatType["AsyncMessageListRequest"] = 32] = "AsyncMessageListRequest";
        AgentEventChatType[AgentEventChatType["AsyncMessageHistoricalRequest"] = 33] = "AsyncMessageHistoricalRequest";
        AgentEventChatType[AgentEventChatType["AsyncMessageReceived"] = 34] = "AsyncMessageReceived";
        AgentEventChatType[AgentEventChatType["AsyncMessageScreenPop"] = 35] = "AsyncMessageScreenPop";
        AgentEventChatType[AgentEventChatType["AsyncMessageRemoved"] = 36] = "AsyncMessageRemoved";
        AgentEventChatType[AgentEventChatType["AsyncMessageListResponse"] = 37] = "AsyncMessageListResponse";
        AgentEventChatType[AgentEventChatType["AsyncMessageHistoricalResponse"] = 38] = "AsyncMessageHistoricalResponse";
        AgentEventChatType[AgentEventChatType["GetAsyncMessageError"] = 39] = "GetAsyncMessageError";
        AgentEventChatType[AgentEventChatType["AsyncMessageReplyResponse"] = 40] = "AsyncMessageReplyResponse";
        AgentEventChatType[AgentEventChatType["AsyncMessageTimeout"] = 41] = "AsyncMessageTimeout";
        AgentEventChatType[AgentEventChatType["Error"] = 42] = "Error";
        AgentEventChatType[AgentEventChatType["AsyncMessageDismissRequest"] = 43] = "AsyncMessageDismissRequest";
        AgentEventChatType[AgentEventChatType["AsyncMessageDismissResponse"] = 44] = "AsyncMessageDismissResponse";
        AgentEventChatType[AgentEventChatType["AsyncMessageListRepliedRequest"] = 45] = "AsyncMessageListRepliedRequest";
        AgentEventChatType[AgentEventChatType["AsyncMessageListRepliedResponse"] = 46] = "AsyncMessageListRepliedResponse";
        AgentEventChatType[AgentEventChatType["AsyncMessageResetReadingTimeoutRequest"] = 47] = "AsyncMessageResetReadingTimeoutRequest";
        AgentEventChatType[AgentEventChatType["AsyncMessageResetReadingTimeoutResponse"] = 48] = "AsyncMessageResetReadingTimeoutResponse";
        AgentEventChatType[AgentEventChatType["TransferRequest"] = 49] = "TransferRequest";
        AgentEventChatType[AgentEventChatType["TransferResponse"] = 50] = "TransferResponse";
        AgentEventChatType[AgentEventChatType["AssistantMode"] = 52] = "AssistantMode";
    })(AgentEventChatType || (AgentEventChatType = {}));
    exports.AgentChannelStatus = void 0;
    (function (AgentChannelStatus) {
        AgentChannelStatus[AgentChannelStatus["None"] = 0] = "None";
        AgentChannelStatus[AgentChannelStatus["Idle"] = 1] = "Idle";
        AgentChannelStatus[AgentChannelStatus["Pause"] = 4] = "Pause";
        AgentChannelStatus[AgentChannelStatus["Ending"] = 5] = "Ending";
        AgentChannelStatus[AgentChannelStatus["Chat"] = 11] = "Chat";
        AgentChannelStatus[AgentChannelStatus["Pausing"] = 62] = "Pausing";
        AgentChannelStatus[AgentChannelStatus["End"] = 9999] = "End";
    })(exports.AgentChannelStatus || (exports.AgentChannelStatus = {}));

    var EnumManualCallState = {
        Nothing: { id: -1, value: 'Nothing' },
        Started: { id: 0, value: 'Started' },
        Alerting: { id: 1, value: 'Alerting' },
        CustomerConnected: { id: 2, value: 'CustomerConnected' },
        Routing: { id: 3, value: 'Routing' },
        AgentConnected: { id: 4, value: 'AgentConnected' },
        Finished: { id: 5, value: 'Finished' },
        Consulting: { id: 6, value: 'Consulting' },
        Transfering: { id: 7, value: 'Transfering' },
        Queue: { id: 8, value: 'Queue' },
        Holding: { id: 9, value: 'Holding' },
    };
    var CallStatus;
    (function (CallStatus) {
        CallStatus["Started"] = "Started";
        CallStatus["CustomerConnected"] = "CustomerConnected";
        CallStatus["Finished"] = "Finished";
        CallStatus["AgentConnected"] = "AgentConnected";
    })(CallStatus || (CallStatus = {}));

    var OlosAgent = /** @class */ (function () {
        function OlosAgent() {
            var _this = this;
            this._agentId = '';
            this.setStatus = function (stats) {
                Logger.getInstance().info("DEBUG :: setStatus " + stats);
                _this._status = stats;
                if (_this.isAgentInWrapStatus()) {
                    trigger('dispositionPending', null);
                    off('dispositionPending');
                }
                if (_this._status === EnumAgentStatus.PAUSE.value) {
                    trigger('pauseCancel', _this._agentId);
                    off('pauseCancel');
                    trigger('changePauseReason', _this._agentId);
                    off('changePauseReason');
                }
                //wrapTmoCheck();
            };
            this.isAgentInWrapStatus = function () {
                return (_this._status === EnumAgentStatus.WRAP.value ||
                    _this._status === EnumAgentStatus.WRAP_WITH_PAUSE.value ||
                    _this._status === EnumAgentStatus.WRAP_WITH_PRIVATE_CALLBACK.value ||
                    _this._status === EnumAgentStatus.WRAP_WITH_MANUAL_CALL.value ||
                    _this._status === EnumAgentStatus.WRAP_WITH_ENDING.value ||
                    _this._status === EnumAgentStatus.WRAP_WITH_PERSONAL_CALL.value);
            };
            this.isAgentInPendingPauseStatus = function () {
                return (_this._status === EnumAgentStatus.TALKING_WITH_PAUSE.value ||
                    _this._status === EnumAgentStatus.WRAP_WITH_PAUSE.value);
            };
            this.setManualCallStatus = function (stats) {
                _this._manualCallStatus = stats;
                if (_this.isManualCallWrap()) {
                    trigger('dispositionPending', null);
                    off('dispositionPending');
                }
            };
            this.isManualCallWrap = function () {
                return _this._manualCallStatus == EnumManualCallState.Finished.value;
            };
            this._status = EnumManualCallState.Nothing.value;
        }
        Object.defineProperty(OlosAgent.prototype, "agentID", {
            get: function () {
                return this._agentId;
            },
            set: function (value) {
                this._agentId = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OlosAgent.prototype, "status", {
            get: function () {
                return this._status;
            },
            enumerable: false,
            configurable: true
        });
        return OlosAgent;
    }());

    var OlosAgentChannel = /** @class */ (function () {
        function OlosAgentChannel() {
            this._agentId = 0;
            this._status = exports.AgentChannelStatus.None;
        }
        Object.defineProperty(OlosAgentChannel.prototype, "agentID", {
            get: function () {
                return this._agentId;
            },
            set: function (value) {
                this._agentId = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OlosAgentChannel.prototype, "status", {
            get: function () {
                return this._status;
            },
            set: function (value) {
                this._status = value;
            },
            enumerable: false,
            configurable: true
        });
        return OlosAgentChannel;
    }());

    var convertToJson = function (value) {
        if (typeof value !== 'string')
            return value;
        var text = value.replace(/^\(/, '').replace(/\);$/, '');
        return JSON.parse(text);
    };

    var _started = false;
    var _listeners = {};
    /**
     * start
     */
    var start = function () {
        _started = true;
        if (worker) {
            worker.onmessage = function (ev) {
                if (ev && ev.data && ev.data.url) {
                    triggerWorkerMessage(ev.data.url, ev);
                }
            };
        }
        else {
            console.warn("Warning! The worker did not start");
        }
    };
    /**
     * onMessage
     * @param handler
     */
    var onWorkerMessage = function (endpoint, handler) {
        if (!_started) {
            start();
        }
        _listeners[endpoint] = _listeners[endpoint] || [];
        _listeners[endpoint].push(handler);
    };
    /**
     * triggerMessage
     * @param data
     */
    var triggerWorkerMessage = function (endpoint, data) {
        if (_listeners[endpoint]) {
            _listeners[endpoint].forEach(function (handler) { return handler(data); });
        }
    };

    var OlosAgentChannelWs = /** @class */ (function () {
        function OlosAgentChannelWs() {
            var _this = this;
            this._worker = false;
            this._hasWorker = typeof Worker !== 'undefined';
            this._agentChannel = new OlosAgentChannel();
            this._callbacks = {};
            this._hasLoggedOnce = false;
            this._apiOnline = true;
            this._status = 1;
            this._agentEvtUrl = "";
            this.defaultCallError = function (eventRenew) {
                _this._apiOnline = false;
                if (eventRenew && !_this._hasWorker)
                    _this._apiConnectTimeout = setTimeout(_this.getNextEventChat.bind(_this), 1500);
            };
            this.start = function (agentId) {
                _this.stop();
                on('onTokenUpdate', _this._onTokenUpdate);
                _this._status = 1;
                _this._hasLoggedOnce = false;
                _this._agentChannel.agentID = agentId;
                _this._agentChannel.status = exports.AgentChannelStatus.None; /*NOTHING*/
                if (_this._hasWorker) {
                    _this._worker = true;
                    _this._agentEvtUrl = getAddress('wsAgentEvt') + "/GetNextEventChat";
                    worker.postMessage({
                        eventType: 'init',
                        agentEvtUrl: _this._agentEvtUrl,
                    });
                    return _this.getNextEventChatWorker();
                }
                _this.getNextEventChat();
            };
            this.stop = function () {
                Logger.getInstance().info("DEBUG :: stop this._hasWorker " + _this._hasWorker + " e this._worker " + _this._worker);
                _this._status = 0;
                off('onTokenUpdate', _this._onTokenUpdate);
                if (_this._hasWorker && _this._worker) {
                    worker.postMessage({
                        eventType: 'stop',
                        agentEvtUrl: _this._agentEvtUrl,
                    });
                    return (_this._worker = false);
                }
                clearTimeout(_this._setTmoId1);
                clearTimeout(_this._setTmoId2);
                return clearTimeout(_this._apiConnectTimeout);
            };
            this.createReqId = function (dialogueId) {
                var now = new Date();
                return dialogueId + "_" + now.getMinutes().toString() + now.getSeconds().toString() + now
                    .getMilliseconds()
                    .toString();
            };
            this.agentAuthenticationChat = function (login, passwd, callback) {
                var data = {
                    Login: login,
                    Password: passwd,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationChat', data)
                    .then(function (res) {
                    var agentId = convertToJson(res.data).agentId;
                    if (agentId && Number(agentId) > 0) {
                        _this.start(agentId);
                        return callback ? callback(agentId) : trigger('agentAuthenticationChat', agentId);
                    }
                    return trigger('agentAuthenticationChatFail', agentId);
                })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.agentAuthenticationAzureChat = function (tokenId, callback) {
                var data = {
                    TokenId: tokenId,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationAzureChat', data)
                    .then(function (res) {
                    var agentId = convertToJson(res.data).agentId;
                    if (agentId && Number(agentId) > 0) {
                        _this.start(agentId);
                        return callback ? callback(agentId) : trigger('agentAuthenticationAzureChat', agentId);
                    }
                    return trigger('agentAuthenticationChatAzureFail', agentId);
                })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.agentAuthenticationISAMChat = function (tokenId, callback, callbackError) {
                var data = {
                    Token: tokenId,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationISAMChat', data)
                    .then(function (response) {
                    var agentId = convertToJson(response.data).agentId;
                    if (agentId && Number(agentId) > 0) {
                        _this.start(agentId);
                        return callback ? callback(agentId) : trigger('agentAuthenticationISAMChat', agentId);
                    }
                    return callbackError
                        ? callbackError('agentAuthenticationISAMChatFail')
                        : trigger('agentAuthenticationISAMChatFail', agentId);
                })
                    .catch(function (error) {
                    _this.defaultCallError();
                    return callbackError ? callbackError(error) : trigger('agentAuthenticationISAMChatFail', error);
                });
            };
            this.agentAuthenticationChatWithPause = function (login, passwd, reasonCode, callback) {
                var data = {
                    ReasonCode: reasonCode,
                    Login: login,
                    Password: passwd,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationChatWithPause', data)
                    .then(function (res) {
                    var agentId = convertToJson(res.data).agentId;
                    if (agentId && Number(agentId) > 0) {
                        _this.start(agentId);
                        return callback ? callback(agentId) : trigger('AgentAuthenticationChatWithPause', agentId);
                    }
                    return trigger('AgentAuthenticationChatWithPauseFail', agentId);
                })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.agentAuthenticationAzureChatWithPause = function (tokenId, reasonCode, callback) {
                var data = {
                    ReasonCode: reasonCode,
                    TokenId: tokenId,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationChatAzureWithPause', data)
                    .then(function (res) {
                    var agentId = convertToJson(res.data).agentId;
                    if (agentId && Number(agentId) > 0) {
                        _this.start(agentId);
                        return callback ? callback(agentId) : trigger('AgentAuthenticationAzureChatWithPause', agentId);
                    }
                    return trigger('AgentAuthenticationAzureChatWithPauseFail', agentId);
                })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.agentAuthenticationChatISAMWithPause = function (tokenId, reasonCode, callback, callbackError) {
                var data = {
                    ReasonCode: reasonCode,
                    Token: tokenId,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationChatISAMWithPause', data)
                    .then(function (response) {
                    var agentId = convertToJson(response.data).agentId;
                    if (agentId && Number(agentId) > 0) {
                        _this.start(agentId);
                        return callback ? callback(agentId) : trigger('agentAuthenticationChatISAMWithPause', agentId);
                    }
                    return callbackError
                        ? callbackError('agentAuthenticationChatISAMWithPauseFail')
                        : trigger('agentAuthenticationChatISAMWithPauseFail', agentId);
                })
                    .catch(function (error) {
                    _this.defaultCallError();
                    return callbackError ? callbackError(error) : trigger('agentAuthenticationChatISAMWithPauseFail', error);
                });
            };
            this.agentReasonChatRequest = function (reasonId) {
                var data = {
                    ReasonId: reasonId,
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "AgentReasonChatRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.agentReasonChatRequestByCode = function (reasonCode) {
                var data = {
                    ReasonCode: reasonCode,
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "AgentReasonChatRequestByCode";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.agentIdleChatRequest = function () {
                var data = {
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "AgentIdleChatRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.agentChannelLogout = function () {
                var data = {
                    AgentId: _this._agentChannel.agentID,
                };
                Logger.getInstance().info("DEBUG :: agentChannelLogout");
                var url = "AgentChatLogout";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.dispositionChat = function (dialogId, dispositionId, dispositionCode, year, month, day, hour, minute, privateAgent) {
                var data = {
                    DialogId: dialogId,
                    DispositionId: dispositionId,
                    DispositionCode: dispositionCode,
                    Year: year,
                    Month: month,
                    Day: day,
                    Hour: hour,
                    Minute: minute,
                    Private: privateAgent,
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "DispositionChat";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.messageChatRequest = function (dialogId, message, attachments) {
                var reqId = dialogId ? _this.createReqId(dialogId) : null;
                var data = {
                    Message: message,
                    Attachments: attachments,
                    ReqId: reqId,
                    DialogId: dialogId,
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "MessageChatRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
                return reqId != null ? { dialogId: dialogId, reqId: reqId } : null;
            };
            this.currentDialogsRequest = function (campaignId) {
                var data = {
                    AgentId: _this._agentChannel.agentID,
                    CampaignId: campaignId,
                };
                var url = "CurrentDialogsRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.messageNotice = function (agentId, dialogId, messageid, status) {
                var url = "MessageNotice?agentId=" + agentId + "&DialogId=" + dialogId + "&Messageid=" + messageid + "&Status=" + status;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.listOnlineAgentsInCampaign = function (campaignId) {
                var url = "ListOnlineAgentsInCampaign?campaignId=" + campaignId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    trigger('ListOnlineAgentsInCampaign', { response: convertToJson(res.data), campaignId: campaignId });
                })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.getAmountCallsInQueue = function (campaignId) {
                var url = "GetAmountCallsInQueue?campaignId=" + campaignId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    trigger('GetAmountCallsInQueue', { response: convertToJson(res.data), campaignId: campaignId });
                })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.consultingAssistedCampaignRequest = function (AgentId, CampaignId, TransferAgentId, uuiData) {
                var data = {
                    CampaignId: CampaignId,
                    TransferAgentId: TransferAgentId,
                    Uui: uuiData,
                    AgentId: AgentId,
                };
                var url = "ConsultingAssistedCampaignRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.typing = function (dialogId) {
                var data = {
                    DialogId: dialogId,
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "Typing";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.listChatDispositions = function (campaignId) {
                var url = "ListChatDispositions?AgentId=" + _this._agentChannel.agentID + "&CampaignId=" + campaignId;
                agentCMDAPI.APIInstance().get(url);
            };
            this.listChatPauseReasons = function () {
                var url = "ListChatPauseReasons?AgentId=" + _this._agentChannel.agentID;
                agentCMDAPI.APIInstance().get(url);
            };
            this.resetChatInactivityTimer = function (dialogId) {
                var data = {
                    DialogId: dialogId,
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "ResetChatInactivityTimer";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.getMailingHistory = function (mailingName, recordId, maxResults, lastDaysLimit, dialogId) {
                var url = "GetMailingHistory?mailingName=" + mailingName + "&recordId=" + recordId + "&maxResults=" + maxResults + "&lastDaysLimit=" + lastDaysLimit;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('GetMailingHistory', { response: convertToJson(res.data), dialogId: dialogId }); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.agentDailySummary = function (agentId) {
                var data = {
                    AgentId: agentId,
                };
                var url = "AgentDailySummary";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return trigger('AgentDailySummary', convertToJson(res.data)); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.asyncMessageReply = function (agentId, conversationId, content, attachments, formatedContent) {
                var data = {
                    Content: content,
                    Attachments: attachments,
                    FormatedContent: formatedContent,
                    ConversationId: conversationId,
                    AgentId: agentId,
                };
                var url = "AsyncMessageReply";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.asyncMessageDismiss = function (agentId, conversationId) {
                var data = {
                    ConversationId: conversationId,
                    AgentId: agentId,
                };
                var url = "AsyncMessageDismiss";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.getAsyncMessage = function (agentId, conversationId) {
                var url = "GetAsyncMessage?AgentId=" + agentId + "&ConversationId=" + conversationId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.asyncMessageListRequest = function (agentId, campaignId) {
                var url = "AsyncMessageListRequest?AgentId=" + agentId + "&CampaignId=" + campaignId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.asyncMessageListRepliedRequest = function (agentId, campaignId) {
                var url = "AsyncMessageListRepliedRequest?AgentId=" + agentId + "&CampaignId=" + campaignId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.asyncMessageResetReadingTimeoutRequest = function (agentId, conversationId) {
                var url = "AsyncMessageResetReadingTimeoutRequest?AgentId=" + agentId + "&ConversationId=" + conversationId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.asyncMessageHistoricalRequest = function (agentId, conversationId) {
                var url = "AsyncMessageHistoricalRequest?AgentId=" + agentId + "&ConversationId=" + conversationId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.transferChat = function (dialogId, dispositionId, dispositionCode, campaignIdDest, agentIdDest, year, month, day, hour, minute, privateTransfer) {
                var data = {
                    DialogId: dialogId,
                    DispositionId: dispositionId,
                    DispositionCode: dispositionCode,
                    CampaignIdDest: campaignIdDest,
                    AgentIdDest: agentIdDest,
                    Year: year,
                    Month: month,
                    Day: day,
                    Hour: hour,
                    Minute: minute,
                    Private: privateTransfer,
                    AgentId: _this._agentChannel.agentID,
                };
                var url = "TransferChat";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.getListStatus = function () {
                return exports.AgentChannelStatus;
            };
            this.handleNextEvent = function (objEvent) {
                var _a;
                var eventData = objEvent.eventData, eventTypeId = objEvent.eventTypeId, campaignId = objEvent.campaignId, channel = objEvent.channel;
                Logger.getInstance().info("DEBUG :: handleNextEvent");
                var event = (_a = {},
                    _a[AgentEventChatType.LoginResponse] = function () { return (_this._hasLoggedOnce = true); },
                    _a[AgentEventChatType.ChangeStatus] = function () {
                        _this._agentChannel.status = eventData.status;
                    },
                    _a[AgentEventChatType.LogoutCampaign] = function () {
                        Logger.getInstance().info("DEBUG :: handleNextEvent AgentEventChatType.LogoutCampaign campaignId: " + campaignId + " this._hasLoggedOnce: " + _this._hasLoggedOnce);
                        if (campaignId === 0 && _this._hasLoggedOnce) {
                            _this._agentChannel.status = exports.AgentChannelStatus.End;
                            Logger.getInstance().info("DEBUG :: handleNextEvent AgentEventChatType.LogoutCampaign this._agentChannel.status: " + _this._agentChannel.status);
                            _this.stop();
                        }
                    },
                    _a);
                if (event[eventTypeId])
                    event[eventTypeId]();
                //Evento do HeartBeat no Chat serve como um ping para saber se o agente está consumindo os eventos por isso apenas enviamos para o log e não disparamos o evento.
                if (eventTypeId !== AgentEventChatType.Heartbeat) {
                    var eventName = void 0;
                    try {
                        eventName = EventName[eventTypeId].toLowerCase();
                        trigger("chat" + eventName, __assign(__assign({}, eventData), { channel: channel || undefined }));
                    }
                    catch (e) {
                        eventName = '';
                    }
                }
            };
            this._onTokenUpdate = function (data) {
                worker.postMessage({
                    eventType: 'updateToken',
                    agentEvtUrl: _this._agentEvtUrl,
                    authorization: tokenAPI.tokenType + " " + tokenAPI.accessToken,
                });
            };
            this.onWorkerMessage = function (ofType, callback) {
                return function (e) {
                    if (e.data && e.data.eventType === ofType) {
                        callback(e.data.data, e);
                    }
                };
            };
            this.getNextEventChatWorker = function () {
                if (!_this._status)
                    return;
                var onSuccess = _this.onWorkerMessage('event', function (objEvent) {
                    if (_this._apiOnline == false) {
                        _this._apiOnline = true;
                        trigger('apiRequestError', { status: 'online' });
                    }
                    if (objEvent !== null && typeof objEvent === 'object')
                        _this.handleNextEvent(objEvent);
                });
                var onError = _this.onWorkerMessage('error', function (data) {
                    console.error('ERRRO :: GetNextEventChat', data);
                    _this.defaultCallError();
                    Logger.getInstance().info('* Error * Request :: getNextEvent()');
                });
                onWorkerMessage(_this._agentEvtUrl, function (ev) {
                    onSuccess(ev);
                    onError(ev);
                });
                worker.postMessage({
                    eventType: 'start',
                    agentId: _this._agentChannel.agentID,
                    agentEvtUrl: _this._agentEvtUrl,
                    authorization: tokenAPI.tokenType + " " + tokenAPI.accessToken,
                });
            };
            this.getNextEventChat = function () {
                if (!_this._status)
                    return;
                var data = "GetNextEventChat?agentId=" + _this._agentChannel.agentID;
                agentEVT
                    .APIInstance()
                    .get(data)
                    .then(function (res) {
                    if (_this._apiOnline === false) {
                        _this._apiOnline = true;
                        trigger('apiRequestError', { status: 'online' });
                    }
                    var objEvent = convertToJson(res.data);
                    var eventTypeId = objEvent.eventTypeId;
                    if (objEvent == null && _this._agentChannel.status !== exports.AgentChannelStatus.End) {
                        clearTimeout(_this._setTmoId1);
                        return (_this._setTmoId1 = setTimeout(_this.getNextEventChat.bind(_this), 1500));
                    }
                    if (typeof objEvent === 'object') {
                        _this.handleNextEvent(objEvent);
                        if (eventTypeId !== AgentEventChatType.Error) {
                            clearTimeout(_this._setTmoId2);
                            return (_this._setTmoId2 = setTimeout(_this.getNextEventChat.bind(_this), 0));
                        }
                        clearTimeout(_this._setTmoId1);
                        return (_this._setTmoId1 = setTimeout(_this.getNextEventChat.bind(_this), 1500));
                    }
                })
                    .catch(function () {
                    _this.defaultCallError();
                    clearTimeout(_this._setTmoId1);
                    _this._setTmoId1 = setTimeout(_this.getNextEventChat.bind(_this), 1500);
                });
            };
        }
        return OlosAgentChannelWs;
    }());

    var OlosActiveCall = /** @class */ (function () {
        function OlosActiveCall() {
            var _this = this;
            this._callIdActive = 0;
            this._callIdMaster = 0;
            this._campaignId = 0;
            this._customerId = '';
            this._tableName = '';
            this._callbacks = {};
            this._arrayActiveCalls = [];
            this.addActiveCall = function (activeCall) {
                if (_this._arrayActiveCalls.indexOf(activeCall) == -1) {
                    _this._arrayActiveCalls.push(activeCall);
                    _this._callIdActive = _this.getLastActiveCall();
                }
            };
            this.getCallIdMaster = function () {
                return _this._callIdMaster;
            };
            this.setCallIdMaster = function (callId) {
                _this._callIdMaster = callId;
            };
            this.renewActiveCall = function (objListActiveCalls) {
                objListActiveCalls.forEach(function (call) {
                    if (call.customerCall == true)
                        _this.setCallIdMaster(call.callId);
                });
                //TODO - Renovar apenas quando quando maior que 1 porque o  primeiro é da ligação atual
                if (_this._arrayActiveCalls.length > 1) {
                    //Montando array de callId ativos
                    var arrayListActiveCalls_1 = objListActiveCalls.map(function (call) { return call.callId; });
                    _this._arrayActiveCalls.filter(function (activeCall) { return arrayListActiveCalls_1.indexOf(activeCall) !== -1; });
                    //Reordenando o array de CallIds Ativos
                    _this._arrayActiveCalls = arrayListActiveCalls_1.sort(function (a, b) { return a - b; });
                }
                _this._callIdActive = _this.getLastActiveCall();
            };
            this.getLastActiveCall = function () {
                return _this._arrayActiveCalls[_this._arrayActiveCalls.length - 1];
            };
            this.resetAll = function () {
                _this._callIdActive = 0;
                _this._callIdMaster = 0;
                _this._campaignId = 0;
                _this._customerId = '';
                _this._tableName = '';
                _this._arrayActiveCalls = [];
            };
        }
        Object.defineProperty(OlosActiveCall.prototype, "campaignID", {
            get: function () {
                return this._campaignId;
            },
            set: function (value) {
                this._campaignId = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OlosActiveCall.prototype, "customerId", {
            get: function () {
                return this._customerId;
            },
            set: function (value) {
                this._customerId = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OlosActiveCall.prototype, "mailingName", {
            get: function () {
                return this._tableName;
            },
            set: function (value) {
                this._tableName = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OlosActiveCall.prototype, "callIdActive", {
            get: function () {
                return this._callIdActive;
            },
            set: function (value) {
                this._callIdActive = value;
            },
            enumerable: false,
            configurable: true
        });
        return OlosActiveCall;
    }());

    var OlosAgentWS = /** @class */ (function () {
        function OlosAgentWS() {
            var _this = this;
            this._worker = false;
            this.hasWorker = typeof Worker !== 'undefined';
            this._hasLoggedOnceCCM = false;
            this._status = 0;
            this._agentId = 0;
            this._apiOnline = true;
            this._setTmoId1 = 0;
            this._setTmoId2 = 0;
            this._apiConnectTimout = 0;
            this._agent = new OlosAgent();
            this._activeCall = new OlosActiveCall();
            this._agentEvtUrl = "";
            this.defaultCallError = function (eventRenew) {
                _this._apiOnline = false;
                if (eventRenew && !_this.hasWorker)
                    _this._apiConnectTimout = setTimeout(_this.getNextEvent.bind(_this), 1500);
            };
            this.start = function () {
                _this.stop();
                on('onTokenUpdate', _this._onTokenUpdate);
                _this._status = 1;
                _this._hasLoggedOnceCCM = false;
                if (_this.hasWorker) {
                    _this._worker = true;
                    _this._agentEvtUrl = getAddress('wsAgentEvt') + "/GetNextEvent";
                    worker.postMessage({
                        eventType: 'init',
                        agentEvtUrl: _this._agentEvtUrl
                    });
                    return _this.getNextEventWorker();
                }
                return _this.getNextEvent();
            };
            this.getNextEventWorker = function () {
                if (!_this._status)
                    return;
                var onSuccess = _this.onWorkerMessage('event', function (objEvent) {
                    if (!_this._apiOnline) {
                        _this._apiOnline = true;
                        trigger('apiRequestError', { status: 'online' });
                    }
                    if (typeof objEvent === 'object')
                        _this.handleNextEvent(objEvent);
                });
                var onError = _this.onWorkerMessage('error', function (data) {
                    console.error('ERRRO :: GetNextEvent', data);
                    _this.defaultCallError(true);
                    Logger.getInstance().error('* Error * Request :: getNextEventWorker()');
                });
                onWorkerMessage(_this._agentEvtUrl, function (ev) {
                    onSuccess(ev);
                    onError(ev);
                });
                worker.postMessage({
                    eventType: 'start',
                    agentId: _this._agentId,
                    agentEvtUrl: _this._agentEvtUrl,
                    authorization: tokenAPI.tokenType + " " + tokenAPI.accessToken,
                });
            };
            this.onWorkerMessage = function (ofType, callback) {
                return function (e) {
                    if (e.data && e.data.eventType === ofType) {
                        callback(e.data.data, e);
                    }
                };
            };
            this.getNextEvent = function () {
                if (!_this._status)
                    return;
                var data = "GetNextEvent?agentId=" + _this._agentId;
                agentEVT
                    .APIInstance()
                    .get(data)
                    .then(function (response) {
                    if (!_this._apiOnline) {
                        _this._apiOnline = true;
                        trigger('apiRequestError', { status: 'online' });
                    }
                    var objEvent = convertToJson(response.data);
                    var agentEventType = objEvent.agentEventType;
                    if (typeof objEvent === 'object') {
                        _this.handleNextEvent(objEvent);
                        if (agentEventType === AgentEventType.NOTHING && _this._agent.status !== EnumAgentStatus.END.value) {
                            clearTimeout(_this._setTmoId1);
                            return (_this._setTmoId1 = setTimeout(_this.getNextEvent.bind(_this), 1500));
                        }
                        clearTimeout(_this._setTmoId2);
                        _this._setTmoId2 = setTimeout(_this.getNextEvent.bind(_this), 0);
                    }
                })
                    .catch(function () {
                    clearTimeout(_this._setTmoId1);
                    _this._setTmoId1 = setTimeout(_this.getNextEvent.bind(_this), 1500);
                });
            };
            this.handleNextEvent = function (objEvent) {
                var _a;
                if (!objEvent || !objEvent.agentEventType) {
                    return;
                }
                var agentEventType = objEvent.agentEventType, genericInt = objEvent.genericInt, eventObject = objEvent.eventObject, eventObjectManualCallState = objEvent.eventObjectManualCallState, eventObjectScreenPop = objEvent.eventObjectScreenPop, eventObjectAgentChangeStatus = objEvent.eventObjectAgentChangeStatus;
                var event = (_a = {},
                    _a[AgentEventType.ACTIVE_CALL] = function () {
                        _this._activeCall.addActiveCall(genericInt);
                        return _this.listActiveCalls();
                    },
                    _a[AgentEventType.LIST_ACTIVE_CALLS] = function () {
                        if (eventObject.length > 0)
                            return _this._activeCall.renewActiveCall(eventObject);
                    },
                    _a[AgentEventType.CHANGE_MANUAL_CALL_STATE] = function () {
                        var callState = eventObjectManualCallState.callState, callId = eventObjectManualCallState.callId;
                        _this._agent.setManualCallStatus(callState);
                        _this._activeCall.setCallIdMaster(callId);
                        return (_this._activeCall.campaignID = 0);
                    },
                    _a[AgentEventType.SCREEN_POP] = function () {
                        var callId = eventObjectScreenPop.callId, campaignId = eventObjectScreenPop.campaignId, customerId = eventObjectScreenPop.customerId, tableName = eventObjectScreenPop.tableName;
                        _this._activeCall.addActiveCall(callId);
                        _this._activeCall.setCallIdMaster(callId);
                        _this._activeCall.campaignID = campaignId;
                        _this._activeCall.customerId = customerId;
                        return (_this._activeCall.mailingName = tableName);
                    },
                    _a[AgentEventType.ChangePreviewCallState] = function () { return _this._activeCall.addActiveCall(eventObject.callId); },
                    _a[AgentEventType.LOGIN_CCM] = function () { return (_this._hasLoggedOnceCCM = true); },
                    _a[AgentEventType.LOGOUT_CCM] = function () { return _this._hasLoggedOnceCCM && _this._agent.setStatus(EnumAgentStatus.END.value); },
                    _a[AgentEventType.CHANGE_STATUS] = function () {
                        var agentID = eventObjectAgentChangeStatus.agentStatusId;
                        _this._agent.setStatus(agentID);
                        var resetCall = agentID === EnumAgentStatus.IDLE.value ||
                            agentID === EnumAgentStatus.MANUAL_CALL.value ||
                            agentID === EnumAgentStatus.PAUSE.value;
                        if (resetCall)
                            return _this._activeCall.resetAll();
                        if (agentID === EnumAgentStatus.HOLDING.value)
                            return _this.listActiveCalls();
                    },
                    _a[AgentEventType.StopConferenceRequestAccepted] = function () { return _this.retrievesCall(_this._activeCall.getCallIdMaster()); },
                    _a);
                if (event[agentEventType])
                    event[agentEventType]();
                Logger.getInstance().info("EventType (agentEventType): [" + agentEventType + "]");
                Logger.getInstance().info("EventData (eventObject): [" + getAllEventObjectProps(eventObject) + "]");
                if (agentEventType === AgentEventType.NOTHING && _this._agent.status === EnumAgentStatus.END.value)
                    return trigger('agentEnd', eventObject);
                return trigger(agentEventType.toLowerCase(), eventObject);
            };
            this.stop = function () {
                _this._status = 0;
                off('onTokenUpdate', _this._onTokenUpdate);
                if (_this.hasWorker && _this._worker) {
                    worker.postMessage({
                        eventType: 'stop',
                        agentEvtUrl: _this._agentEvtUrl,
                    });
                    return (_this._worker = false);
                }
                clearTimeout(_this._setTmoId1);
                clearTimeout(_this._setTmoId2);
                return clearTimeout(_this._apiConnectTimout);
            };
            this.agentAuthentication = function (login, passwd, callback) {
                var data = {
                    Login: login,
                    Password: passwd,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthentication', data)
                    .then(function (response) {
                    var id = convertToJson(response.data).agentId;
                    _this._agent.agentID = id;
                    _this._agentId = id;
                    if (_this._agentId && Number(_this._agentId) > 0) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(id) : trigger('agentAuthentication', id);
                    }
                    return trigger('agentAuthenticationFail', id);
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.authServiceLogin = function (callback) {
                var data = {
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AuthServiceLogin', data)
                    .then(function (response) {
                    var id = convertToJson(response.data).agentId;
                    _this._agent.agentID = id;
                    _this._agentId = id;
                    if (_this._agentId && Number(_this._agentId) > 0) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(id) : trigger('agentAuthentication', id);
                    }
                    return trigger('agentAuthenticationFail', id);
                }).catch(function (response) {
                    console.log(response);
                });
            };
            this.agentAuthenticationAuthServiceLogin = function (callback) {
                var data = {
                    ForceLogout: true,
                };
                agentCLD
                    .APIInstance()
                    .post('AuthServiceUnextendedAgentLogin', data)
                    .then(function (response) {
                    var id = convertToJson(response.data).agentId;
                    _this._agent.agentID = id;
                    _this._agentId = id;
                    if (_this._agentId && Number(_this._agentId) > 0) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        return callback ? callback(id) : trigger('agentAuthentication', id);
                    }
                    return trigger('agentAuthenticationFail', id);
                }).catch(function (response) {
                    console.log(response);
                });
            };
            this.agentAuthenticationAzure = function (tokenId, callback, callbackError) {
                var data = {
                    TokenId: tokenId,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationAzure', objToUrlencoded(data))
                    .then(function (response) {
                    var _a = convertToJson(response.data), error = _a.error, agentId = _a.agentId;
                    _this._agent.agentID = agentId;
                    if (agentId > 0 && !error) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(agentId) : trigger('agentAuthenticationAzure', String(agentId));
                    }
                    return callbackError ? callbackError(error) : trigger('agentAuthenticationAzureFail', error);
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.agentAuthenticationISAM = function (
            // eslint-disable-next-line @typescript-eslint/ban-types
            token, callback, callbackError) {
                var data = {
                    Token: token,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationISAM', data)
                    .then(function (response) {
                    var _a = convertToJson(response.data), error = _a.error, agentId = _a.agentId;
                    _this._agent.agentID = agentId;
                    _this._agentId = agentId;
                    if (agentId > 0 && !error) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(agentId) : trigger('agentAuthenticationISAM', String(agentId));
                    }
                    return callbackError ? callbackError(error) : trigger('agentAuthenticationISAMFail', error);
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.agentAuthenticationWithPause = function (login, passwd, reasonCode, callback) {
                var data = {
                    ReasonCode: reasonCode,
                    Login: login,
                    Password: passwd,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationWithPause', data)
                    .then(function (response) {
                    var agentId = convertToJson(response.data).agentId;
                    _this._agent.agentID = agentId;
                    if (agentId > 0) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(agentId) : trigger('agentAuthenticationWithPause', String(agentId));
                    }
                    return trigger('agentAuthenticationWithPauseFail', agentId);
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.agentAuthenticationISAMPause = function (tokenId, reasonCode, callback) {
                var data = {
                    TokenId: tokenId,
                    ReasonCode: reasonCode,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationISAMWithPause', objToUrlencoded(data))
                    .then(function (response) {
                    var _a = convertToJson(response.data), error = _a.error, agentId = _a.agentId;
                    _this._agent.agentID = agentId;
                    if (agentId > 0 && !error) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(agentId) : trigger('agentAuthenticationISAMPause', String(agentId));
                    }
                    return trigger('agentAuthenticationISAMWithPauseFail', error);
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.agentAuthenticationAzureWithPause = function (tokenId, reasonCode, callback) {
                var data = {
                    ReasonCode: reasonCode,
                    TokenId: tokenId,
                    ForceLogout: true,
                };
                agentCMDAPI
                    .APIInstance()
                    .post('AgentAuthenticationAzureWithPause', objToUrlencoded(data))
                    .then(function (response) {
                    var _a = convertToJson(response.data), error = _a.error, agentId = _a.agentId;
                    _this._agent.agentID = agentId;
                    if (agentId > 0 && !error) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(agentId) : trigger('agentAuthenticationAzureWithPause', String(agentId));
                    }
                    return trigger('agentAuthenticationAzureWithPauseFail', error);
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.agentReasonRequest = function (reasonId) {
                var reasonRequest = function (agentId, reasonId) {
                    var data = {
                        ReasonId: reasonId,
                        AgentId: agentId,
                    };
                    var url = "AgentReasonRequest";
                    agentCMDAPI.APIInstance().post(url, data);
                };
                var agentId = _this._agent.agentID;
                if (_this._agent.isAgentInPendingPauseStatus())
                    return on('changePauseReason', function () { return reasonRequest(agentId, reasonId); });
                return reasonRequest(agentId, reasonId);
            };
            this.agentReasonRequestByCode = function (reasonCode) {
                var reasonRequest = function (agentId, reasonCode) {
                    var data = {
                        ReasonCode: reasonCode,
                        AgentId: agentId,
                    };
                    var url = "AgentReasonRequestByCode";
                    agentCMDAPI.APIInstance().post(url, data);
                };
                var agentId = _this._agent.agentID;
                if (_this._agent.isAgentInPendingPauseStatus())
                    return on('changePauseReason', function () { return reasonRequest(agentId, reasonCode); });
                return reasonRequest(agentId, reasonCode);
            };
            this.coordinatedAgentPause = function (reasonId, reasonCode) {
                var pauseRequest = function (agentId, reasonId, reasonCode) {
                    var data = {
                        ReasonCode: reasonCode,
                        ReasonId: reasonId,
                        AgentId: agentId,
                    };
                    var url = "CoordinatedAgentPause";
                    agentCMDAPI.APIInstance().post(url, data);
                };
                var agentId = _this._agent.agentID;
                if (_this._agent.isAgentInPendingPauseStatus())
                    return on('changePauseReason', function () { return pauseRequest(agentId, reasonId, reasonCode); });
                return pauseRequest(agentId, reasonId, reasonCode);
            };
            this.agentIdleRequest = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "AgentIdleRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.agentIdleChatRequest = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "AgentIdleChatRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.agentLogout = function () {
                Logger.getInstance().info("DEBUG :: agentLogout this._agent.agentID " + _this._agent.agentID);
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "AgentLogout";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.coordinatedAgentLogout = function () {
                Logger.getInstance().info("DEBUG :: agentLogout coordinatedAgentLogout " + _this._agent.agentID);
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "CoordinatedAgentLogout";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.updateAgentIpAddress = function (ip) {
                var data = {
                    Ip: ip,
                    AgentId: _this._agent.agentID,
                };
                var url = "UpdateAgentIpAddress";
                agentCMDAPI.APIInstance().put(url, data);
            };
            this.updateMailingData = function (mailingData) {
                var data = {
                    MailingName: _this._activeCall.mailingName,
                    MailingData: mailingData,
                    CustomerId: _this._activeCall.customerId,
                    AgentId: _this._agent.agentID,
                    CampaignId: _this._activeCall.campaignID,
                };
                var url = "UpdateMailingData";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.updateCallData = function (campaignData, callback, callbackError) {
                var data = {
                    CampaignData: campaignData,
                    CustomerId: _this._activeCall.customerId,
                    AgentId: _this._agent.agentID,
                    CallId: _this._activeCall.callIdActive,
                };
                var url = "updateCallData";
                agentCMDAPI.APIInstance()
                    .put(url, data)
                    .then(function (res) { return !!callback && callback(res.data); })
                    .catch(function (error) { return !!callbackError && callbackError({ response: error.response, err: error }); });
            };
            this.transferCallRequest = function (callId) {
                var targetCallId = callId || _this._activeCall.callIdActive;
                var data = {
                    AgentId: _this._agent.agentID,
                    CallId: targetCallId,
                };
                var url = "TransferCallRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function () { return _this.listActiveCalls(); });
            };
            this.blindTransferCallRequest = function (phoneNumber, uuiData) {
                var data = {
                    PhoneNumber: phoneNumber,
                    Uui: uuiData,
                    AgentId: _this._agent.agentID,
                };
                var url = "BlindTransferCallRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.sendPreviewCallRequest = function (phoneNumber) {
                var data = {
                    PhoneNumber: phoneNumber,
                    AgentId: _this._agent.agentID,
                };
                var url = "SendPreviewCallRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.sendManualCallRequest = function (ddd, phoneNumber, campaignId) {
                var data = {
                    Ddd: ddd,
                    PhoneNumber: phoneNumber,
                    CampaignId: campaignId,
                    AgentId: _this._agent.agentID,
                };
                var url = "SendManualCallRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.retrievesCall = function (callId) {
                var data = {
                    AgentId: _this._agent.agentID,
                    CallId: callId || _this._activeCall.callIdActive,
                };
                var url = "RetrievesCall";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.redialRequest = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "RedialRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.redialRequestWithPhone = function (ddi, phoneNumber) {
                var data = {
                    AgentId: _this._agent.agentID,
                    Ddi: ddi,
                    PhoneNumber: phoneNumber,
                };
                var url = "RedialRequestWithPhone";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.markRecordingRequest = function (callId, description) {
                var data = {
                    Description: description,
                    AgentId: _this._agent.agentID,
                    CallId: callId,
                };
                var url = "MarkRecordingRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.manualCallStateRequest = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "ManualCallStateRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.listReasons = function (callback) {
                var url = "ListReasons?agentId=" + _this._agent.agentID;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    var list = convertToJson(res.data);
                    if (callback)
                        return callback(list);
                    return trigger('listReasons', list);
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.listOnlineAgents = function () {
                var url = "ListOnlineAgents?agentId=" + _this._agent.agentID;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    trigger('listOnlineAgents', convertToJson(res.data));
                })
                    .catch(function () {
                    _this.defaultCallError();
                });
            };
            this.listDispositions = function (campaignId) {
                var url = "ListDispositions?campaignId=" + (campaignId || _this._activeCall.campaignID);
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    var response = convertToJson(res.data);
                    trigger('listDispositions', response);
                    trigger('listDispositionsCampaign', { campaignId: campaignId, dispositions: response });
                });
            };
            this.listCompanies = function () {
                var url = "ListCompanies?agentId=" + _this._agent.agentID;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('listCompanies', convertToJson(res.data)); });
            };
            this.listCampaignsToConsulting = function (campaignId) {
                var url = "ListCampaignsToConsulting?CampaignId=" + (campaignId || _this._activeCall.campaignID);
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('listCampaignsToConsulting', convertToJson(res.data)); });
            };
            this.listCampaignsToChat = function (campaignId) {
                var url = "ListCampaignsToChat?CampaignId=" + (campaignId || _this._activeCall.campaignID);
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('listCampaignsToChat', convertToJson(res.data)); });
            };
            this.listCampaignCompany = function () {
                agentCMDAPI
                    .APIInstance()
                    .get('ListCampaignCompany')
                    .then(function (res) { return trigger('listCampaignCompany', convertToJson(res.data)); });
            };
            this.listActiveCalls = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "ListActiveCalls";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return trigger('listActiveCalls', convertToJson(res.data)); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.hangupRequest = function (callId) {
                var targetCallId = callId || _this._activeCall.callIdActive;
                var data = {
                    AgentId: _this._agent.agentID,
                    CallId: targetCallId,
                };
                var url = "HangupRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function () { return _this.listActiveCalls(); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.hangupAndDispositionCallByCode = function (dispositionCode) {
                var data = {
                    DispositionCode: dispositionCode,
                    AgentId: _this._agent.agentID,
                    CallId: _this._activeCall.callIdActive,
                };
                var url = "HangupAndDispositionCallByCode";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.hangupAndDispositionCallBackByCode = function (dispositionCode, year, month, day, hour, minute, phoneNumber, specificAgent) {
                var callId = _this._activeCall.getCallIdMaster();
                var data = {
                    DispositionCode: dispositionCode,
                    Year: year,
                    Month: month,
                    Day: day,
                    Hour: hour,
                    Minute: minute,
                    PhoneNumber: phoneNumber,
                    SpecificAgent: specificAgent || true,
                    AgentId: _this._agent.agentID,
                    CallId: callId,
                };
                var url = "HangupAndDispositionCallBackByCode";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.hangupAndDispositionCallBack = function (dispositionId, year, month, day, hour, minute, phoneNumber, specificAgent) {
                var data = {
                    DispositionId: dispositionId,
                    Year: year,
                    Month: month,
                    Day: day,
                    Hour: hour,
                    Minute: minute,
                    PhoneNumber: phoneNumber,
                    SpecificAgent: specificAgent || true,
                    AgentId: _this._agent.agentID,
                    CallId: _this._activeCall.callIdActive,
                };
                var url = "HangupAndDispositionCallBack";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.hangupAndDispositionCall = function (dispositionId) {
                var data = {
                    DispositionId: dispositionId,
                    AgentId: _this._agent.agentID,
                    CallId: _this._activeCall.getCallIdMaster(),
                };
                var url = "HangupAndDispositionCall";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.endManualCallStateRequest = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "EndManualCallStateRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.dispositionCallByCode = function (dispositionCode) {
                var callId = _this._activeCall.getCallIdMaster();
                var agent = _this._agent;
                var data = {
                    DispositionCode: dispositionCode,
                    AgentId: agent.agentID,
                    CallId: callId,
                };
                var dispCallByCode = function () {
                    var url = "DispositionCallByCode";
                    agentCMDAPI
                        .APIInstance()
                        .post(url, data)
                        .catch(function () { return _this.defaultCallError(); });
                };
                if (agent.isAgentInWrapStatus() || agent.isManualCallWrap())
                    return dispCallByCode();
                on('dispositionPending', function () { return dispCallByCode(); });
                _this.hangupRequest(callId);
            };
            this.listAvailableOnlineAgents = function () {
                var url = "ListAvailableOnlineAgents?agentId=" + _this._agent.agentID;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('listAvailableOnlineAgents', convertToJson(res.data)); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.dispositionCallBackByCode = function (dispositionCode, year, month, day, hour, minute, phoneNumber, specificAgent) {
                var callId = _this._activeCall.getCallIdMaster();
                var agent = _this._agent;
                var dispCallbackByCode = function () {
                    var data = {
                        DispositionCode: dispositionCode,
                        Year: year,
                        Month: month,
                        Day: day,
                        Hour: hour,
                        Minute: minute,
                        PhoneNumber: phoneNumber,
                        SpecificAgent: specificAgent || true,
                        AgentId: agent.agentID,
                        CallId: callId,
                    };
                    var url = "DispositionCallBackByCode";
                    agentCMDAPI
                        .APIInstance()
                        .post(url, data)
                        .catch(function () { return _this.defaultCallError(); });
                };
                if (agent.isAgentInWrapStatus() || agent.isManualCallWrap())
                    return dispCallbackByCode();
                on('dispositionPending', function () { return dispCallbackByCode(); });
                _this.hangupRequest(callId);
            };
            this.dispositionCallBack = function (dispositionId, year, month, day, hour, minute, phoneNumber, specificAgent, forceCallId) {
                if (specificAgent === void 0) { specificAgent = false; }
                var callId = forceCallId || _this._activeCall.getCallIdMaster();
                var agent = _this._agent;
                var dispCallback = function () {
                    var data = {
                        DispositionId: dispositionId,
                        Year: year,
                        Month: month,
                        Day: day,
                        Hour: hour,
                        Minute: minute,
                        PhoneNumber: phoneNumber,
                        SpecificAgent: specificAgent || true,
                        AgentId: agent.agentID,
                        CallId: callId,
                    };
                    var url = "DispositionCallBack";
                    agentCMDAPI
                        .APIInstance()
                        .post(url, data)
                        .catch(function () { return _this.defaultCallError(); });
                };
                if (agent.isAgentInWrapStatus() || agent.isManualCallWrap())
                    return dispCallback();
                on('dispositionPending', function () { return dispCallback(); });
                _this.hangupRequest(callId);
            };
            this.dispositionCall = function (dispositionId, forceCallId) {
                var callId = forceCallId || _this._activeCall.getCallIdMaster();
                var agent = _this._agent;
                var dispCall = function () {
                    var data = {
                        DispositionId: dispositionId,
                        AgentId: agent.agentID,
                        CallId: callId,
                    };
                    var url = "DispositionCall";
                    agentCMDAPI
                        .APIInstance()
                        .post(url, data)
                        .catch(function () { return _this.defaultCallError(); });
                };
                if (agent.isAgentInWrapStatus() || agent.isManualCallWrap())
                    return dispCall();
                on('dispositionPending', function () { return dispCall(); });
                _this.hangupRequest(callId);
            };
            this.consultingRequest = function (phoneNumber, campaignId, uuiData) {
                var data = {
                    PhoneNumber: phoneNumber,
                    CampaignId: campaignId,
                    Uui: uuiData || null,
                    AgentId: _this._agent.agentID,
                };
                var url = "ConsultingRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.consultingAgentRequest = function (transferAgentId, transferLogin, uuiData) {
                var data = {
                    TransferAgentId: transferAgentId,
                    TransferLogin: transferLogin,
                    Uui: uuiData,
                    AgentId: _this._agent.agentID,
                };
                var url = "ConsultingAgentRequest";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.closeCustomer = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "CloseCustomer";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.closeCustomerWithDispositionId = function (dispositionId) {
                var data = {
                    DispositionId: dispositionId,
                    AgentId: _this._agent.agentID,
                };
                var url = "CloseCustomerWithDispositionId";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.closeCustomerWithDispositionCode = function (dispositionCode) {
                var url = "CloseCustomerWithDispositionCode?agentId=" + _this._agent.agentID + "&dispositionCode=" + dispositionCode;
                agentCMDAPI.APIInstance().get(url);
            };
            this.conferenceRequest = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "ConferenceRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.stopConferenceRequest = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "StopConferenceRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.referCallRequest = function (agentId, phoneNumber, uui, address) {
                var _agentId = agentId || _this._agent.agentID;
                var data = {
                    Address: address,
                    PhoneNumber: phoneNumber,
                    Uui: uui,
                    AgentId: _agentId,
                };
                var url = "ReferCallRequest";
                agentCMDAPI.APIInstance().post(url, data);
            };
            this.getMailingHistory = function (mailingName, recordId, maxResults, lastDaysLimit, dialogId) {
                var url = "GetMailingHistory?mailingName=" + mailingName + "&recordId=" + recordId + "&maxResults=" + maxResults + "&lastDaysLimit=" + lastDaysLimit;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('GetMailingHistory', { response: convertToJson(res.data), dialogId: dialogId }); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.getRecordHistory = function (mailingName, recordId, customerId, maxResults, lastDaysLimit, dialogId) {
                var url = "GetRecordHistory?mailingName=" + mailingName + "&recordId=" + recordId + "&customerId=" + customerId + "&maxResults=" + maxResults + "&lastDaysLimit=" + lastDaysLimit;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('GetRecordHistory', { response: convertToJson(res.data), dialogId: dialogId }); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.getAsyncRecordHistory = function (history) { return __awaiter(_this, void 0, void 0, function () {
                var customerId, dialogId, lastDaysLimit, mailingName, maxResults, recordId, url, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            customerId = history.customerId, dialogId = history.dialogId, lastDaysLimit = history.lastDaysLimit, mailingName = history.mailingName, maxResults = history.maxResults, recordId = history.recordId;
                            url = "GetRecordHistory?mailingName=" + mailingName + "&recordId=" + recordId + "&customerId=" + customerId + "&maxResults=" + maxResults + "&lastDaysLimit=" + lastDaysLimit;
                            return [4 /*yield*/, agentCMDAPI.APIInstance().get(url)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, { response: convertToJson(response.data), dialogId: dialogId }];
                    }
                });
            }); };
            this.agentDailySummary = function (agentId) {
                var _agentId = agentId || _this._agent.agentID;
                var data = {
                    AgentId: _agentId,
                };
                var url = "AgentDailySummary";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return trigger('AgentDailySummary', convertToJson(res.data)); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.getMySupervisor = function (agentId) {
                var _agentId = agentId || _this._agent.agentID;
                var url = "GetMySupervisor?agentId=" + _agentId;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('getMySupervisor', convertToJson(res.data)); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.retrieveSupervisioningMessages = function (agentId, supervisorId, range_start, range_end, broadcast, received) {
                var _agentId = agentId || _this._agent.agentID;
                var url = "RetrieveSupervisioningMessages?agentId=" + _agentId + "&supervisorId=" + supervisorId + "&range_start=" + range_start + "&range_end=" + range_end + "&broadcast=" + broadcast + "&received=" + received;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return trigger('retrieveSupervisioningMessages', { response: convertToJson(res.data) }); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.sendMessageToSupervisor = function (agentId, supervisorId, message) {
                var _agentId = agentId || _this._agent.agentID;
                var data = {
                    SupervisorId: supervisorId,
                    Message: message,
                    AgentId: _agentId,
                };
                var url = "SendMessageToSupervisor";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return trigger('SendMessageToSupervisor', { response: convertToJson(res.data) }); })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.pauseRecording = function (callId, beep, timeout) {
                var targetBeep = beep ? 1 : 0;
                var targetCallId = callId || _this._activeCall.callIdActive;
                var data = {
                    Beep: targetBeep,
                    Timeout: timeout,
                    AgentId: _this._agent.agentID,
                    CallId: targetCallId,
                };
                var url = "PauseRecording";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.resumeRecording = function (callId, beep, timeout) {
                var targetBeep = beep ? 1 : 0;
                var targetCallId = callId || _this._activeCall.callIdActive;
                var data = {
                    Beep: targetBeep,
                    Timeout: timeout,
                    AgentId: _this._agent.agentID,
                    CallId: targetCallId,
                };
                var url = "ResumeRecording";
                agentCMDAPI
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.extendWrapTimeoutRequest = function (seconds) {
                var targetCallId = _this._activeCall.callIdActive;
                var url = "ExtendWrapTimeoutRequest?AgentId=" + _this._agent.agentID + "&CallId=" + targetCallId + "&Seconds=" + seconds;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.listAgentsOnlineWithCampaigns = function () {
                var url = "ListAgentsOnlineWithCampaigns?agentId=" + _this._agent.agentID;
                agentCMDAPI
                    .APIInstance()
                    .get(url)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.unextendedAgentLogin = function (login, passwd, phoneNumber, callback) {
                var data = {
                    PhoneNumber: phoneNumber,
                    Login: login,
                    Password: passwd,
                    ForceLogout: true,
                };
                var url = "UnextendedAgentLogin";
                agentCLD
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) {
                    var agentId = convertToJson(res.data).agentId;
                    _this._agentId = agentId;
                    if (agentId > 0) {
                        _this._agent.setStatus(EnumAgentStatus.NOTHING);
                        _this.start();
                        return callback ? callback(agentId) : trigger('unextendedAgentLogin', agentId);
                    }
                    return trigger('unextendedAgentLoginFail', agentId);
                })
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.connectAgentLoginCall = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "ConnectAgentLoginCall";
                agentCLD
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.dropAgentLoginCall = function () {
                var data = {
                    AgentId: _this._agent.agentID,
                };
                var url = "DropAgentLoginCall";
                agentCLD
                    .APIInstance()
                    .post(url, data)
                    .catch(function () { return _this.defaultCallError(); });
            };
            this.setCurrentCustomer = function (mailingName, recordId, indexId, callData, callback, callbackError) {
                var data = {
                    MailingName: mailingName,
                    RecordId: recordId,
                    IndexId: indexId,
                    AgentId: (callData && callData.agentId) || _this._agent.agentID,
                    CallId: (callData && callData.callId) || _this._activeCall.callIdActive,
                    CustomerId: (callData && callData.customerId) || _this._activeCall.customerId,
                };
                var url = 'SetCurrentCustomer';
                agentCMDAPI.APIInstance().post(url, data)
                    .then(callback)
                    .catch(callbackError);
            };
            this.thirdPartyEventRequest = function (agentID, eventData) {
                var url = "ThirdPartyEventRequest?AgentId=" + (_this._agent.agentID || agentID) + "&EventData=" + eventData;
                agentCMDAPI.APIInstance().post(url);
            };
            this._onTokenUpdate = function (data) {
                worker.postMessage({
                    eventType: 'updateToken',
                    agentEvtUrl: _this._agentEvtUrl,
                    authorization: tokenAPI.tokenType + " " + tokenAPI.accessToken,
                });
            };
        }
        Object.defineProperty(OlosAgentWS.prototype, "agentID", {
            get: function () {
                return this._agentId;
            },
            set: function (value) {
                this._agentId = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OlosAgentWS.prototype, "status", {
            get: function () {
                return this._status;
            },
            set: function (value) {
                this._status = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OlosAgentWS.prototype, "getActiveCall", {
            get: function () {
                return this._activeCall;
            },
            enumerable: false,
            configurable: true
        });
        return OlosAgentWS;
    }());

    var OlosMailingWS = /** @class */ (function () {
        function OlosMailingWS() {
            var _this = this;
            this.setActiveCall = function (actCall) {
                _this._activeCall = actCall;
            };
            this.listMailings = function (campaignId, callback) {
                var url = "ListMailings?CampaignId=" + campaignId;
                mailingCMD
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    return callback ? callback(convertToJson(res.data)) : trigger('listMailings', convertToJson(res.data));
                });
            };
            this.finalizeClient = function (mailingName, dispId, customerId, callback) {
                var data = {
                    DispositionId: dispId,
                    MailingName: mailingName,
                    CustomerId: customerId,
                };
                var url = "FinalizeClient";
                mailingCMD
                    .APIInstance()
                    .put(url, data)
                    .then(function (res) {
                    return callback ? callback(convertToJson(res.data)) : trigger('finalizeClient', convertToJson(res.data));
                });
            };
            this.finalizeClientByDispositionCode = function (campaignId, mailingName, dispCode, customerId, callback) {
                var data = {
                    CampaignId: campaignId,
                    DispositionCode: dispCode,
                    MailingName: mailingName,
                    CustomerId: customerId,
                };
                var url = "FinalizeClientByDispositionCode";
                mailingCMD
                    .APIInstance()
                    .put(url, data)
                    .then(function (res) {
                    return callback
                        ? callback(convertToJson(res.data))
                        : trigger('finalizeClientByDispositionCode', convertToJson(res.data));
                });
            };
            this.invalidatePhoneNumber = function (ddd, phoneNumber, callback) {
                var data = {
                    DDD: ddd,
                    PhoneNumber: phoneNumber,
                    MailingName: _this._activeCall.tableName,
                    CustomerId: _this._activeCall.customerId,
                };
                var url = "FinalizeClientByPhoneNumber";
                mailingCMD
                    .APIInstance()
                    .put(url, data)
                    .then(function (res) {
                    return callback ? callback(convertToJson(res.data)) : trigger('invalidatePhoneNumber', convertToJson(res.data));
                });
            };
            this.insertPhoneNumber = function (ddd, phoneNumber, callback) {
                var data = {
                    TypePhoneId: 1,
                    PhoneNumber: "" + ddd + phoneNumber,
                    MailingName: _this._activeCall.tableName,
                    CustomerId: _this._activeCall.customerId,
                };
                var url = "InsertPhoneNumber";
                mailingCMD
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) {
                    return callback ? callback(convertToJson(res.data)) : trigger('insertPhoneNumber', convertToJson(res.data));
                });
            };
            this.updateMailingData = function (field, data, callback) {
                var mailingData = {
                    FieldMailing: field,
                    DataField: data,
                    MailingName: _this._activeCall.tableName,
                    CustomerId: _this._activeCall.customerId,
                };
                var url = "UpdateMailingData";
                mailingCMD
                    .APIInstance()
                    .put(url, mailingData)
                    .then(function (res) {
                    return callback ? callback(convertToJson(res.data)) : trigger('updateMailingData', convertToJson(res.data));
                });
            };
            this.upsertRecordData = function (_a, callbackSuccess, callbackError) {
                var LayoutId = _a.LayoutId, MailingDataJson = _a.MailingDataJson, MailingName = _a.MailingName, CampaignId = _a.CampaignId, CustomerId = _a.CustomerId;
                var upsertData = {
                    LayoutId: LayoutId,
                    MailingDataJson: MailingDataJson,
                    MailingName: MailingName,
                    CampaignId: CampaignId,
                    CustomerId: CustomerId,
                };
                var url = 'UpsertRecordData';
                mailingCMD
                    .APIInstance()
                    .post(url, upsertData)
                    .then(function (res) { return callbackSuccess(res.data); })
                    .catch(function (err) { return callbackError(err); });
            };
            this.customerCallback = function (callbackData, callbackSuccess, callbackError) {
                var url = 'CustomerCallback';
                mailingCMD
                    .APIInstance()
                    .post(url, callbackData)
                    .then(function (res) { return callbackSuccess(res.data); })
                    .catch(function (err) { return callbackError(err); });
            };
            this.unfinalizeClient = function (_a, callbackSuccess, callbackError) {
                var DispositionId = _a.DispositionId, MailingName = _a.MailingName, CustomerId = _a.CustomerId;
                var mailingData = {
                    DispositionId: DispositionId,
                    MailingName: MailingName,
                    CustomerId: CustomerId,
                };
                var url = "UnfinalizeClient";
                mailingCMD
                    .APIInstance()
                    .put(url, mailingData)
                    .then(function (res) { return callbackSuccess(res); })
                    .catch(function (err) { return callbackError(err); });
            };
        }
        return OlosMailingWS;
    }());

    var OlosMcx = /** @class */ (function () {
        function OlosMcx() {
            var _this = this;
            this._defaultTimeout = 1000;
            this.getJourney = function (timeout, callbackSuccess, callbackError) {
                var data = {
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'GetJourney';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
            this.disposition = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    dispositionArgs: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'Disposition';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function (err) { return callbackError(err); });
            };
            this.phoneInfoReq = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    args: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'PhoneInfoReq';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
            this.search = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    informationArgs: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'Search';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
            this.delJourneyFromSms = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    delJourneyArgs: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'DelJourneyFromSms';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
            this.recordInfo = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    informationArgs: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'RecordInfo';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
            this.recordInfoEncrypt = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    data: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'RecordInfoEncrypt';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
            this.setRecordInUse = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    setRecInUseArgs: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'SetRecordInUse';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
            this.addHistory = function (information, timeout, callbackSuccess, callbackError) {
                var data = {
                    addHistoryArgs: information,
                    msecTimeout: timeout || _this._defaultTimeout,
                };
                var url = 'AddHistory';
                mcxAPI
                    .APIInstance()
                    .post(url, data)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function () { return callbackError(); });
            };
        }
        return OlosMcx;
    }());

    var OlosRecordingRetrieve = /** @class */ (function () {
        function OlosRecordingRetrieve() {
            var _this = this;
            this.getConversation = function (conversatioId, conversationDate, max, callbackSuccess, callbackError) {
                var params = max
                    ? "conversatioId=" + conversatioId + "&conversationDate=" + conversationDate + "&maxLimit=" + max
                    : "conversatioId=" + conversatioId + "&conversationDate=" + conversationDate;
                var url = "Conversation?" + params;
                recordingRetrieveAPI
                    .APIInstance()
                    .get(url)
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function (err) { return callbackError(err); });
            };
            this.getAgentConversation = function (agentId, conversationDate, max, callbackSuccess, callbackError) {
                var params = {
                    agentId: String(agentId),
                    conversationDate: conversationDate,
                    maxLimit: max,
                };
                var url = "Agent";
                recordingRetrieveAPI
                    .APIInstance()
                    .get(url, { params: params })
                    .then(function (res) { return callbackSuccess(convertToJson(res.data)); })
                    .catch(function (err) { return callbackError(err); });
            };
            this.getConversationByCustomer = function (params) { return __awaiter(_this, void 0, void 0, function () {
                var url, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "Customer";
                            return [4 /*yield*/, recordingRetrieveAPI.APIInstance().get(url, { params: params })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.data];
                    }
                });
            }); };
            this.getConversationByUser = function (params) { return __awaiter(_this, void 0, void 0, function () {
                var url, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "User";
                            return [4 /*yield*/, recordingRetrieveAPI.APIInstance().get(url, { params: params })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.data];
                    }
                });
            }); };
        }
        return OlosRecordingRetrieve;
    }());

    var OlosSoftPhone = /** @class */ (function () {
        function OlosSoftPhone() {
            this.getPbxToLogin = function (callbackSuccess, callbackError) {
                var url = 'GetPbxToLogin';
                softPhoneAPI
                    .APIInstance()
                    .get(url)
                    .then(function (data) { return callbackSuccess && callbackSuccess(data); })
                    .catch(function (error) { return callbackError && callbackError(error); });
            };
        }
        return OlosSoftPhone;
    }());

    var OlosUserConfigWS = /** @class */ (function () {
        function OlosUserConfigWS() {
            var _this = this;
            this.getCampaignByUserLogin = function (login, loginOwner, passwordOwner, callback, callbackError) {
                // const data = {
                // 	login:login,
                // 	loginOwner: loginOwner,
                // 	passwordOwner: passwordOwner
                // }
                // const url = `GetCampaignByUserLogin`
                var url = "GetCampaignByUserLogin?login=" + login;
                agentConfigCMD
                    .APIInstance()
                    .get(url)
                    // .post(url, data)
                    .then(function (response) { return callback(convertToJson(response.data)); })
                    .catch(function (error) { return callbackError && callbackError(error); });
            };
            this.getChatSupervisorAgent = function (agentId, callback) {
                var url = "GetChatSupervisorAgent?AgentId=" + agentId;
                agentConfigCMD
                    .APIInstance()
                    .get(url)
                    .then(function (response) {
                    return callback
                        ? callback.call(_this, response)
                        : trigger('getchatsupervisoragent', convertToJson(response.data));
                });
            };
        }
        return OlosUserConfigWS;
    }());

    // TODO - Esse WS ainda não foi migrado para WEB API com Token e esta na fila de desenvolvimento
    var OlosVoiceSupportWS = /** @class */ (function () {
        function OlosVoiceSupportWS() {
            var _this = this;
            this.callVoiceSupportWS = function (url, triggerName, callback) {
                voiceSupport
                    .APIInstance()
                    .get(url)
                    .then(function (response) {
                    return callback ? callback.call(_this, response) : trigger(triggerName, convertToJson(response.data));
                });
            };
            this.start = function (agentLogin, audio, callback) {
                var url = "VoiceSupportStart?paramAgentLogin=" + agentLogin + "&paramFileName=" + audio;
                _this.callVoiceSupportWS(url, 'voicesupportstart', callback);
            };
            this.pause = function (agentLogin, callback) {
                var url = "VoiceSupportPause?paramAgentLogin=" + agentLogin;
                _this.callVoiceSupportWS(url, 'voicesupportpause', callback);
            };
            this.resume = function (agentLogin, callback) {
                var url = "VoiceSupportResume?paramAgentLogin=" + agentLogin;
                _this.callVoiceSupportWS(url, 'voicesupportresume', callback);
            };
            this.stop = function (agentLogin, callback) {
                var url = "VoiceSupportStop?paramAgentLogin=" + agentLogin;
                _this.callVoiceSupportWS(url, 'voicesupportstop', callback);
            };
        }
        return OlosVoiceSupportWS;
    }());

    var OlosIntegrationWs = /** @class */ (function () {
        function OlosIntegrationWs() {
            this.listAvailableOnlineAgentsByCompany = function (agentId, callback) {
                var url = "ListAvailableOnlineAgentsByCompany?AgentId=" + agentId;
                integrationCMD
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    return callback ? callback(convertToJson(res.data)) : trigger('listAvailableOnlineAgentsByCompany', convertToJson(res.data));
                });
            };
            this.listCampaignsToConsulting = function (campaignId, callback) {
                var url = "ListCampaignsToConsulting?CampaignId=" + campaignId;
                integrationCMD
                    .APIInstance()
                    .get(url)
                    .then(function (res) {
                    return callback ? callback(convertToJson(res.data)) : trigger('listCampaignsToConsulting', convertToJson(res.data));
                });
            };
        }
        return OlosIntegrationWs;
    }());

    exports.Logger = Logger;
    exports.OlosAgent = OlosAgent;
    exports.OlosAgentChannel = OlosAgentChannel;
    exports.OlosAgentChannelWs = OlosAgentChannelWs;
    exports.OlosAgentWS = OlosAgentWS;
    exports.OlosIntegrationWs = OlosIntegrationWs;
    exports.OlosMailingWS = OlosMailingWS;
    exports.OlosMcx = OlosMcx;
    exports.OlosRecordingRetrieve = OlosRecordingRetrieve;
    exports.OlosSoftPhone = OlosSoftPhone;
    exports.OlosUserConfigWS = OlosUserConfigWS;
    exports.OlosVoiceSupportWS = OlosVoiceSupportWS;
    exports.createOlos = createOlos;
    exports.createOlosCognito = createOlosCognito;
    exports.olosOff = off;
    exports.olosOn = on;
    exports.setCognitoToken = setCognitoToken;
    exports.terminateWorker = terminateWorker;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
